import React, { useState, useEffect, useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';

// Modales sobre <body>: ningún contenedor animado los encierra
const CpPortal = ({ children }) => (typeof document !== 'undefined' ? createPortal(children, document.body) : children);

const API = 'https://talku.online';
const SF = "'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif";

const getToken = () => localStorage.getItem('talku_token') || '';
const authH = () => ({ 'Authorization': `Bearer ${getToken()}`, 'Content-Type': 'application/json' });

const fmtN = (v) => { if (!v && v !== 0) return '0'; return Number(v).toLocaleString('es-CO'); };
const fmtPct = (v) => { if (!v && v !== 0) return '0%'; return v.toFixed(1) + '%'; };
const fmtDate = (d) => {
  if (!d) return '';
  const dt = new Date(d);
  const now = new Date();
  const diff = Math.floor((now - dt) / 60000);
  if (diff < 1) return 'Ahora';
  if (diff < 60) return `Hace ${diff}m`;
  if (diff < 1440) return `Hace ${Math.floor(diff/60)}h`;
  const dd = dt.getDate().toString().padStart(2,'0');
  const mm = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'][dt.getMonth()];
  return `${dd} ${mm}`;
};

const STATUS_MAP = {
  draft:     { label: 'Borrador',   color: '#8e8e93', bg: '#f2f2f7' },
  scheduled: { label: 'Programada', color: '#007aff', bg: '#e8f0fe' },
  sending:   { label: 'Enviando',   color: '#ff9500', bg: '#fff3e0' },
  sent:      { label: 'Enviada',    color: '#34c759', bg: '#e8f5e9' },
  paused:    { label: 'Pausada',    color: '#ff3b30', bg: '#ffeaea' },
  failed:    { label: 'Fallida',    color: '#ff3b30', bg: '#ffeaea' },
};

const TYPE_ICONS = {
  whatsapp: (s=16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="#25d366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>,
  email: (s=16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="#007aff" strokeWidth="1.8" strokeLinecap="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>,
  sms: (s=16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="#ff9500" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><line x1="8" y1="9" x2="16" y2="9"/><line x1="8" y1="13" x2="13" y2="13"/></svg>,
};

const TYPE_LABELS = { whatsapp: 'WhatsApp', email: 'Correo', sms: 'SMS' };

/* No demo data — all real from API */


export default function Campaigns({ user, onNav, onLogout }) {
  const [tab, setTab] = useState('campaigns');
  const [channels, setChannels] = useState({ whatsapp:true, email:false, sms:false });
  const [campaigns, setCampaigns] = useState([]);
  const [audiences, setAudiences] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [filter, setFilter] = useState('all');
  const [showCreate, setShowCreate] = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [showImport, setShowImport] = useState(false);
  const [showNewList, setShowNewList] = useState(false);
  const [searchQ, setSearchQ] = useState('');

  // Create campaign state
  const [cType, setCType] = useState('');
  const [cStep, setCStep] = useState(0);
  const [cName, setCName] = useState('');
  const [cAudience, setCAudience] = useState('');
  const [cTemplate, setCTemplate] = useState('');
  const [cSubject, setCSubject] = useState('');
  const [cBody, setCBody] = useState('');
  const [cSchedule, setCSchedule] = useState('now');
  const [cDate, setCDate] = useState('');
  const [cTime, setCTime] = useState('09:00');
  const [cTplQ, setCTplQ] = useState('');
  const [cErr, setCErr] = useState('');
  const [cSaving, setCSaving] = useState(false);

  // Import state
  const [importFile, setImportFile] = useState(null);
  const [importPreview, setImportPreview] = useState(null);
  const [importListName, setImportListName] = useState('');
  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const fileRef = useRef(null);

  // New list state
  const [nlName, setNlName] = useState('');
  const [nlDesc, setNlDesc] = useState('');
  const [nlColor, setNlColor] = useState('#007aff');

  // Add contact manual state
  const [showAddContact, setShowAddContact] = useState(null);
  const [acPhone, setAcPhone] = useState('');
  const [acName, setAcName] = useState('');

  // Create template state
  const [showCreateTpl, setShowCreateTpl] = useState(false);
  const [tplName, setTplName] = useState('');
  const [tplCategory, setTplCategory] = useState('MARKETING');
  const [tplLang, setTplLang] = useState('es_CO');
  const [tplHeaderType, setTplHeaderType] = useState('NONE');
  const [tplHeaderText, setTplHeaderText] = useState('');
  const [tplBody, setTplBody] = useState('');
  const [tplFooter, setTplFooter] = useState('');
  const [tplButtons, setTplButtons] = useState([]);
  const [tplBodyExamples, setTplBodyExamples] = useState([]);
  const [tplHeaderFile, setTplHeaderFile] = useState(null);
  const [tplHeaderHandle, setTplHeaderHandle] = useState('');
  const [tplUploading, setTplUploading] = useState(false);
  const [tplSubmitting, setTplSubmitting] = useState(false);
  const [tplResult, setTplResult] = useState(null);
  const [tplDeleting, setTplDeleting] = useState(null);
  const tplFileRef = useRef(null);

  const resetCreate = () => {
    setCTplQ(''); setCErr(''); setCSaving(false);
    setCType(''); setCStep(0); setCName(''); setCAudience('');
    setCTemplate(''); setCSubject(''); setCBody('');
    setCSchedule('now'); setCDate(''); setCTime('09:00');
    setShowCreate(false);
  };

  // Load data from API
  useEffect(() => {
    (async () => {
      // Templates
      try {
        const r = await fetch(`${API}/whatsapp/templates`, { headers: authH() });
        if (r.ok) {
          const d = await r.json();
          const tplList = d.data || d.templates || [];
          if (tplList.length > 0) {
            setTemplates(tplList.map((t,i) => ({
              id: t.id || i+100, name: t.name, lang: t.language || 'es',
              category: t.category || 'MARKETING', status: t.status || 'APPROVED',
              body: (t.components || []).find(c => c.type === 'BODY')?.text || t.name,
              header: (t.components || []).find(c => c.type === 'HEADER'),
              footer: (t.components || []).find(c => c.type === 'FOOTER')?.text || '',
              buttons: (t.components || []).find(c => c.type === 'BUTTONS')?.buttons || [],
            })));
          }
        }
      } catch {}
      // Campaigns
      try {
        const r = await fetch(`${API}/campaigns/`, { headers: authH() });
        if (r.ok) {
          const d = await r.json();
          if (d.campaigns) setCampaigns(d.campaigns);
        }
      } catch {}
      // Canales disponibles para esta empresa
      try {
        const r = await fetch(`${API}/campaigns/channels`, { headers: authH() });
        if (r.ok) setChannels(await r.json());
      } catch {}
      // Audiences
      try {
        const r = await fetch(`${API}/campaigns/audiences`, { headers: authH() });
        if (r.ok) {
          const d = await r.json();
          if (d.audiences) setAudiences(d.audiences);
        }
      } catch {}
    })();
  }, []);

  // Auto-refresh while any campaign is sending
  useEffect(() => {
    const hasSending = campaigns.some(c => c.status === 'sending');
    if (!hasSending) return;
    const iv = setInterval(async () => {
      try {
        const r = await fetch(`${API}/campaigns/`, { headers: authH() });
        if (r.ok) {
          const d = await r.json();
          if (d.campaigns) setCampaigns(d.campaigns);
        }
      } catch {}
    }, 5000);
    return () => clearInterval(iv);
  }, [campaigns]);

  // KPIs
  const totalSent = campaigns.reduce((s,c) => s + (c.metrics?.sent || 0), 0);
  // Entrega y lectura solo existen de verdad en WhatsApp (avisos de estado de Meta)
  const waCamps = campaigns.filter(c => c.type === 'whatsapp');
  const waSent = waCamps.reduce((s,c) => s + (c.metrics?.sent || 0), 0);
  const totalDelivered = waCamps.reduce((s,c) => s + (c.metrics?.delivered || 0), 0);
  const totalRead = waCamps.reduce((s,c) => s + (c.metrics?.read || 0), 0);
  const totalFailed = campaigns.reduce((s,c) => s + (c.metrics?.failed || 0), 0);
  const deliveryRate = waSent > 0 ? (totalDelivered / waSent) * 100 : 0;
  const openRate = totalDelivered > 0 ? (totalRead / totalDelivered) * 100 : 0;

  // Filtered campaigns
  const filtered = campaigns.filter(c => {
    if (filter === 'whatsapp') return c.type === 'whatsapp';
    if (filter === 'email') return c.type === 'email';
    if (filter === 'sms') return c.type === 'sms';
    if (filter === 'drafts') return c.status === 'draft';
    if (filter === 'sent') return c.status === 'sent';
    return true;
  }).filter(c => !searchQ || c.name.toLowerCase().includes(searchQ.toLowerCase()));

  // CSV Import handler
  const handleFileSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setImportFile(file);
    const reader = new FileReader();
    reader.onload = (ev) => {
      const text = ev.target.result;
      const lines = text.split('\n').filter(l => l.trim());
      const firstLine = lines[0];
      const sep = firstLine.includes(';') ? ';' : firstLine.includes('\t') ? '\t' : ',';
      const headers = firstLine.split(sep).map(h => h.trim().replace(/["']/g,''));
      const rows = lines.slice(1, 6).map(l => {
        const vals = l.split(sep).map(v => v.trim().replace(/["']/g,''));
        const obj = {};
        headers.forEach((h,i) => { obj[h] = vals[i] || ''; });
        return obj;
      });
      setImportPreview({ headers, rows, total: lines.length - 1 });
    };
    reader.readAsText(file);
  };

  const handleImport = async () => {
    if (!importFile || !importListName.trim() || !importPreview) return;
    setImporting(true);
    try {
      const r1 = await fetch(`${API}/campaigns/audiences`, {
        method: 'POST', headers: authH(),
        body: JSON.stringify({ name: importListName, description: `Importados desde ${importFile.name}`, color: '#5ac8fa' }),
      });
      const d1 = await r1.json();
      if (!r1.ok || !d1.audience) {
        setImportResult({ error: d1.detail || 'Error al crear la lista' });
        setImporting(false);
        return;
      }
      const audId = d1.audience.id;

      const text = await importFile.text();
      const lines = text.split('\n').filter(l => l.trim());
      const firstLine = lines[0];
      const sep = firstLine.includes(';') ? ';' : firstLine.includes('\t') ? '\t' : ',';
      const hdrs = firstLine.split(sep).map(h => h.trim().replace(/["']/g,'').toLowerCase());
      const phoneCol = hdrs.findIndex(h => h === 'phone' || h.includes('tel') || h.includes('celular') || h.includes('numero') || h.includes('móvil') || h.includes('movil'));
      const nameCol = hdrs.findIndex(h => h.includes('nombre') || h.includes('first name') || h.includes('name'));
      const lastNameCol = hdrs.findIndex(h => h.includes('apellido') || h.includes('last name'));
      const emailCol = hdrs.findIndex(h => h.includes('email') || h.includes('correo') || h.includes('mail'));

      if (phoneCol === -1) {
        setImportResult({ error: 'No se encontró columna de teléfono. Usa: telefono, phone, celular o numero.' });
        setImporting(false);
        return;
      }

      const contacts = [];
      for (let i = 1; i < lines.length; i++) {
        const vals = lines[i].split(sep).map(v => v.trim().replace(/["']/g,''));
        let phone = (vals[phoneCol] || '').replace(/[^0-9+]/g, '');
        if (!phone) continue;
        if (/^3\d{9}$/.test(phone)) phone = '57' + phone;
        if (!phone.startsWith('+')) phone = '+' + phone;
        let name = nameCol >= 0 ? (vals[nameCol] || '') : '';
        if (lastNameCol >= 0 && vals[lastNameCol] && vals[lastNameCol] !== '-') {
          name = (name + ' ' + vals[lastNameCol]).trim();
        }
        contacts.push({
          phone,
          name,
          email: emailCol >= 0 ? (vals[emailCol] || '') : '',
        });
      }

      const BATCH = 200;
      let totalAdded = 0;
      for (let i = 0; i < contacts.length; i += BATCH) {
        const batch = contacts.slice(i, i + BATCH);
        const r2 = await fetch(`${API}/campaigns/audiences/${audId}/contacts`, {
          method: 'POST', headers: authH(), body: JSON.stringify(batch),
        });
        if (r2.ok) {
          const d2 = await r2.json();
          totalAdded += d2.added || 0;
        }
      }

      setImportResult({ importados: totalAdded, total: contacts.length, errores: contacts.length - totalAdded });
      setAudiences(prev => [...prev, { ...d1.audience, count: totalAdded }]);
    } catch (err) {
      setImportResult({ error: err.message });
    }
    setImporting(false);
  };

  const handleCreateCampaign = async () => {
    const selTpl = templates.find(t => t.name === cTemplate);
    const payload = {
      name: cName,
      type: cType,
      audience_id: parseInt(cAudience) || null,
      template: cType === 'whatsapp' ? cTemplate : null,
      template_language: selTpl ? selTpl.lang : 'es',
      subject: cType === 'email' ? cSubject : null,
      body: (cType === 'email' || cType === 'sms') ? cBody : null,
      schedule: cSchedule,
      scheduled_at: cSchedule === 'later' ? `${cDate}T${cTime}:00-05:00` : null,  // hora Colombia
    };
    setCSaving(true); setCErr('');
    try {
      const r = await fetch(`${API}/campaigns/`, {
        method: 'POST', headers: authH(), body: JSON.stringify(payload),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { setCErr(typeof d.detail === 'string' ? d.detail : 'No se pudo crear la campaña'); setCSaving(false); return; }
      if (d.campaign) setCampaigns(prev => [d.campaign, ...prev]);
    } catch { setCErr('Error de conexión'); setCSaving(false); return; }
    setCSaving(false);
    resetCreate();
  };

  const handleCreateList = async () => {
    if (!nlName.trim()) return;
    const payload = { name: nlName, description: nlDesc, color: nlColor };
    try {
      const r = await fetch(`${API}/campaigns/audiences`, {
        method: 'POST', headers: authH(), body: JSON.stringify(payload),
      });
      const d = await r.json();
      if (r.ok && d.audience) {
        setAudiences(prev => [...prev, d.audience]);
      } else {
        console.error('Create list error:', r.status, d);
        alert('Error al crear lista: ' + (d.detail || JSON.stringify(d)));
      }
    } catch (err) {
      console.error('Create list exception:', err);
      alert('Error de conexión al crear la lista');
    }
    setNlName(''); setNlDesc(''); setNlColor('#007aff');
    setShowNewList(false);
  };

  const resetTplForm = () => {
    setTplName(''); setTplCategory('MARKETING'); setTplLang('es_CO');
    setTplHeaderType('NONE'); setTplHeaderText(''); setTplBody('');
    setTplFooter(''); setTplButtons([]); setTplBodyExamples([]);
    setTplHeaderFile(null); setTplHeaderHandle(''); setTplUploading(false);
    setTplSubmitting(false); setTplResult(null); setShowCreateTpl(false);
  };

  const tplVarsCount = (tplBody.match(/\{\{\d+\}\}/g) || []).length;

  useEffect(() => {
    const count = (tplBody.match(/\{\{\d+\}\}/g) || []).length;
    setTplBodyExamples(prev => {
      const next = [...prev];
      while (next.length < count) next.push('');
      return next.slice(0, count);
    });
  }, [tplBody]);

  const handleHeaderFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setTplHeaderFile(file);
    setTplUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const r = await fetch(`${API}/whatsapp/templates/upload-header`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${getToken()}` },
        body: fd,
      });
      const d = await r.json();
      if (d.ok && d.handle) {
        setTplHeaderHandle(d.handle);
      } else {
        alert('Error al subir imagen: ' + JSON.stringify(d.error || 'desconocido'));
        setTplHeaderFile(null);
      }
    } catch (err) {
      alert('Error de conexión al subir imagen');
      setTplHeaderFile(null);
    }
    setTplUploading(false);
  };

  const handleCreateTemplate = async () => {
    if (!tplName.trim() || !tplBody.trim()) return;
    setTplSubmitting(true);
    try {
      const payload = {
        name: tplName,
        category: tplCategory,
        language: tplLang,
        headerType: tplHeaderType,
        header: tplHeaderType === 'TEXT' ? tplHeaderText : '',
        headerMediaId: tplHeaderHandle || '',
        body: tplBody,
        footer: tplFooter,
        buttons: tplButtons,
        bodyExamples: tplBodyExamples.filter(e => e.trim()),
      };
      const r = await fetch(`${API}/whatsapp/templates`, {
        method: 'POST', headers: authH(), body: JSON.stringify(payload),
      });
      const d = await r.json();
      setTplResult(d);
      if (d.ok) {
        const r2 = await fetch(`${API}/whatsapp/templates`, { headers: authH() });
        if (r2.ok) {
          const d2 = await r2.json();
          const refreshed = d2.data || d2.templates || [];
          if (refreshed.length > 0) {
            setTemplates(refreshed.map((t,i) => ({
              id: t.id || i+100, name: t.name, lang: t.language || 'es',
              category: t.category || 'MARKETING', status: t.status || 'APPROVED',
              body: (t.components || []).find(c => c.type === 'BODY')?.text || t.name,
              header: (t.components || []).find(c => c.type === 'HEADER'),
              footer: (t.components || []).find(c => c.type === 'FOOTER')?.text || '',
              buttons: (t.components || []).find(c => c.type === 'BUTTONS')?.buttons || [],
            })));
          }
        }
      }
    } catch (err) {
      setTplResult({ ok: false, error: err.message });
    }
    setTplSubmitting(false);
  };

  const handleDeleteTemplate = async (name) => {
    if (!window.confirm(`¿Eliminar la plantilla "${name}"?`)) return;
    setTplDeleting(name);
    try {
      let r = await fetch(`${API}/whatsapp/templates/${encodeURIComponent(name)}`, {
        method: 'DELETE', headers: authH(),
      });
      if (r.status === 409) {
        const d = await r.json().catch(() => ({}));
        if (!window.confirm(`⚠️ ${d.detail || 'Talku usa esta plantilla.'}\n\n¿Borrarla de todas formas?`)) { setTplDeleting(null); return; }
        r = await fetch(`${API}/whatsapp/templates/${encodeURIComponent(name)}?force=true`, { method: 'DELETE', headers: authH() });
      }
      if (!r.ok) { const d = await r.json().catch(() => ({})); alert(d.detail || 'No se pudo borrar la plantilla'); setTplDeleting(null); return; }
      setTemplates(prev => prev.filter(t => t.name !== name));
    } catch {}
    setTplDeleting(null);
  };

  const detailCamp = showDetail ? campaigns.find(c => c.id === showDetail) : null;
  const [dLogs, setDLogs] = useState(null);
  const [dOnlyFailed, setDOnlyFailed] = useState(false);
  const [dBusy, setDBusy] = useState(false);
  const [dMsg, setDMsg] = useState('');
  useEffect(() => {
    if (!showDetail || dLogs !== null) return;
    let off = false;
    fetch(`${API}/campaigns/${showDetail}/logs`, { headers: authH() }).then(r => r.ok ? r.json() : { logs: [] })
      .then(d => { if (!off) setDLogs(d.logs || []); }).catch(() => { if (!off) setDLogs([]); });
    return () => { off = true; };
  }, [showDetail, dLogs]); // eslint-disable-line react-hooks/exhaustive-deps

  const TABS = [
    { id:'campaigns', label:'Campañas' },
    { id:'audiences', label:'Audiencias' },
    { id:'templates', label:'Plantillas' },
  ];

  // Crear plantillas en un solo lugar: Configuración → Plantillas (modal con validación de Meta)
  const openTplCreator = () => { try { sessionStorage.setItem('talku_settings_intent', 'nueva_plantilla'); } catch {} if (onNav) onNav('Configuraciones'); };

  const FILTERS = [
    { id:'all', label:'Todas' },
    { id:'whatsapp', label:'WhatsApp' },
    { id:'email', label:'Correo' },
    { id:'sms', label:'SMS' },
    { id:'sent', label:'Enviadas' },
    { id:'drafts', label:'Borradores' },
  ].filter(f => !['email','sms'].includes(f.id) || channels[f.id] || campaigns.some(c => c.type === f.id));

  return (
    <>
      <style>{`
        /* ─── Apple-style Campaigns Module ─── */
        .cp-root {
          height: 100%; overflow-y: auto; overflow-x: hidden;
          padding: 32px 40px 60px;
          font-family: ${SF};
          -webkit-font-smoothing: antialiased;
          background: #f5f5f7;
        }
        .cp-root * { box-sizing: border-box; }

        /* Header */
        .cp-header {
          display: flex; align-items: flex-end; justify-content: space-between;
          margin-bottom: 32px;
        }
        .cp-title {
          font-size: 34px; font-weight: 700; color: #1d1d1f;
          letter-spacing: -.5px; line-height: 1.1;
        }
        .cp-subtitle {
          font-size: 15px; color: #86868b; margin-top: 6px;
          font-weight: 400; letter-spacing: -.1px;
        }

        /* Primary button */
        .cp-btn-primary {
          display: inline-flex; align-items: center; gap: 8px;
          padding: 12px 24px; border-radius: 980px;
          background: #1d1d1f; color: #fff; border: none;
          font-family: inherit; font-size: 14px; font-weight: 600;
          cursor: pointer; letter-spacing: -.1px;
          transition: all .2s cubic-bezier(.4,0,.2,1);
          white-space: nowrap;
        }
        .cp-btn-primary:hover { background: #333; transform: scale(1.03); }
        .cp-btn-primary:active { transform: scale(.97); }

        .cp-btn-secondary {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 10px 20px; border-radius: 980px;
          background: #fff; color: #1d1d1f; border: 1px solid #d2d2d7;
          font-family: inherit; font-size: 13px; font-weight: 500;
          cursor: pointer; transition: all .15s;
        }
        .cp-btn-secondary:hover { background: #f5f5f7; border-color: #bbb; }
        .cp-btn-secondary:active { transform: scale(.97); }

        .cp-btn-ghost {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 8px 16px; border-radius: 980px;
          background: transparent; color: #007aff; border: none;
          font-family: inherit; font-size: 13px; font-weight: 500;
          cursor: pointer; transition: all .15s;
        }
        .cp-btn-ghost:hover { background: rgba(0,122,255,.06); }

        /* Segmented control (Apple-style tabs) */
        .cp-seg {
          display: inline-flex; align-items: center;
          background: rgba(118,118,128,.12);
          border-radius: 10px; padding: 2px;
          margin-bottom: 28px;
        }
        .cp-seg-item {
          padding: 8px 20px; border-radius: 8px;
          border: none; background: transparent;
          font-family: inherit; font-size: 13px; font-weight: 500;
          color: #1d1d1f; cursor: pointer;
          transition: all .2s cubic-bezier(.4,0,.2,1);
          position: relative; z-index: 1;
        }
        .cp-seg-item.active {
          background: #fff; color: #1d1d1f;
          box-shadow: 0 1px 4px rgba(0,0,0,.08), 0 0 1px rgba(0,0,0,.04);
          font-weight: 600;
        }

        /* Filter pills */
        .cp-filters {
          display: flex; gap: 8px; margin-bottom: 24px;
          flex-wrap: wrap;
        }
        .cp-filter {
          padding: 7px 16px; border-radius: 980px;
          border: 1px solid #d2d2d7; background: #fff;
          font-family: inherit; font-size: 12.5px; font-weight: 500;
          color: #424245; cursor: pointer;
          transition: all .15s;
        }
        .cp-filter:hover { border-color: #999; }
        .cp-filter.active {
          background: #1d1d1f; color: #fff; border-color: #1d1d1f;
        }

        /* KPI row */
        .cp-kpis {
          display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px;
          margin-bottom: 32px;
        }
        .cp-kpi {
          background: #fff; border-radius: 16px;
          padding: 24px 24px 20px;
          border: 1px solid rgba(0,0,0,.04);
          transition: transform .2s, box-shadow .2s;
        }
        .cp-kpi:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(0,0,0,.06); }
        .cp-kpi-value {
          font-size: 32px; font-weight: 700; color: #1d1d1f;
          letter-spacing: -.5px; line-height: 1;
        }
        .cp-kpi-label {
          font-size: 13px; color: #86868b; margin-top: 8px;
          font-weight: 500; letter-spacing: -.1px;
        }

        /* Campaign cards */
        .cp-grid {
          display: grid; grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
          gap: 16px;
        }
        .cp-card {
          background: #fff; border-radius: 16px;
          padding: 24px; cursor: pointer;
          border: 1px solid rgba(0,0,0,.04);
          transition: all .2s cubic-bezier(.4,0,.2,1);
          position: relative; overflow: hidden;
        }
        .cp-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 32px rgba(0,0,0,.08);
          border-color: rgba(0,0,0,.08);
        }
        .cp-card-top {
          display: flex; align-items: center; justify-content: space-between;
          margin-bottom: 16px;
        }
        .cp-card-type {
          display: inline-flex; align-items: center; gap: 6px;
          font-size: 12px; font-weight: 600; color: #86868b;
          text-transform: uppercase; letter-spacing: .5px;
        }
        .cp-card-status {
          display: inline-flex; align-items: center;
          padding: 4px 12px; border-radius: 980px;
          font-size: 12px; font-weight: 600;
        }
        .cp-card-name {
          font-size: 18px; font-weight: 600; color: #1d1d1f;
          letter-spacing: -.2px; margin-bottom: 6px;
        }
        .cp-card-meta {
          font-size: 13px; color: #86868b; margin-bottom: 20px;
        }
        .cp-card-bar-wrap {
          height: 6px; background: #f2f2f7; border-radius: 3px;
          overflow: hidden; margin-bottom: 16px;
        }
        .cp-card-bar {
          height: 100%; border-radius: 3px;
          background: linear-gradient(90deg, #34c759, #30d158);
          transition: width .6s cubic-bezier(.4,0,.2,1);
        }
        .cp-card-metrics {
          display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px;
        }
        .cp-card-metric {
          text-align: center;
        }
        .cp-card-metric-val {
          font-size: 16px; font-weight: 700; color: #1d1d1f;
          letter-spacing: -.2px;
        }
        .cp-card-metric-lbl {
          font-size: 11px; color: #aeaeb2; font-weight: 500;
          margin-top: 2px;
        }

        /* Search bar */
        .cp-search-wrap {
          position: relative; margin-bottom: 24px; max-width: 320px;
        }
        .cp-search {
          width: 100%; padding: 10px 16px 10px 40px;
          border: 1px solid #d2d2d7; border-radius: 12px;
          background: #fff; font-family: inherit; font-size: 14px;
          color: #1d1d1f; outline: none;
          transition: border-color .2s, box-shadow .2s;
        }
        .cp-search:focus { border-color: #007aff; box-shadow: 0 0 0 3px rgba(0,122,255,.15); }
        .cp-search-ico {
          position: absolute; left: 14px; top: 50%; transform: translateY(-50%);
          color: #aeaeb2; pointer-events: none;
        }

        /* Modal overlay */
        .cp-overlay {
          position: fixed; inset: 0; z-index: 1000;
          background: rgba(0,0,0,.4);
          display: flex; align-items: center; justify-content: center;
          animation: cpFadeIn .2s ease;
          padding: 20px;
        }
        .cp-modal {
          background: #fff; border-radius: 20px;
          width: 100%; max-width: 640px;
          max-height: 90vh; overflow-y: auto;
          box-shadow: 0 24px 80px rgba(0,0,0,.16);
          animation: cpSlideUp .3s cubic-bezier(.4,0,.2,1);
        }
        .cp-modal-lg { max-width: 800px; }
        .cp-modal-header {
          padding: 24px 28px 0;
          display: flex; align-items: center; justify-content: space-between;
        }
        .cp-modal-title {
          font-size: 22px; font-weight: 700; color: #1d1d1f;
          letter-spacing: -.3px;
        }
        .cp-modal-close {
          width: 32px; height: 32px; border-radius: 50%;
          background: #f2f2f7; border: none; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          color: #86868b; transition: all .15s;
          flex-shrink: 0;
        }
        .cp-modal-close:hover { background: #e5e5ea; color: #1d1d1f; }
        .cp-modal-body { padding: 24px 28px 28px; }

        /* Steps indicator */
        .cp-steps {
          display: flex; align-items: center; gap: 0;
          margin-bottom: 28px; padding: 0 28px;
        }
        .cp-step {
          display: flex; align-items: center; gap: 8px;
          font-size: 13px; font-weight: 500; color: #aeaeb2;
          white-space: nowrap;
        }
        .cp-step.active { color: #1d1d1f; font-weight: 600; }
        .cp-step.done { color: #34c759; }
        .cp-step-num {
          width: 28px; height: 28px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 13px; font-weight: 700;
          background: #f2f2f7; color: #aeaeb2;
          transition: all .2s;
        }
        .cp-step.active .cp-step-num { background: #1d1d1f; color: #fff; }
        .cp-step.done .cp-step-num { background: #34c759; color: #fff; }
        .cp-step-line {
          flex: 1; height: 1px; background: #e5e5ea;
          margin: 0 12px; min-width: 20px;
        }

        /* Type selector cards */
        .cp-type-grid {
          display: grid; grid-template-columns: 1fr 1fr; gap: 16px;
        }
        .cp-type-card {
          padding: 32px 24px; border-radius: 16px;
          border: 2px solid #e5e5ea; background: #fff;
          cursor: pointer; text-align: center;
          transition: all .2s cubic-bezier(.4,0,.2,1);
        }
        .cp-type-card:hover { border-color: #bbb; transform: scale(1.02); }
        .cp-type-card--off, .cp-type-card--off:hover { opacity: .5; cursor: not-allowed; transform: none; border-color: inherit; }
        .cp-type-card.selected { border-color: #007aff; background: #f0f5ff; }
        .cp-type-card-icon {
          width: 56px; height: 56px; border-radius: 16px;
          display: flex; align-items: center; justify-content: center;
          margin: 0 auto 16px;
        }
        .cp-type-card-name {
          font-size: 17px; font-weight: 600; color: #1d1d1f;
          margin-bottom: 6px;
        }
        .cp-type-card-desc {
          font-size: 13px; color: #86868b; line-height: 1.4;
        }

        /* Form fields */
        .cp-field { margin-bottom: 20px; }
        .cp-label {
          display: block; font-size: 13px; font-weight: 600;
          color: #1d1d1f; margin-bottom: 8px; letter-spacing: -.1px;
        }
        .cp-input {
          width: 100%; padding: 12px 16px; border-radius: 12px;
          border: 1px solid #d2d2d7; background: #fff;
          font-family: inherit; font-size: 15px; color: #1d1d1f;
          outline: none; transition: border-color .2s, box-shadow .2s;
        }
        .cp-input:focus { border-color: #007aff; box-shadow: 0 0 0 3px rgba(0,122,255,.12); }
        .cp-textarea {
          width: 100%; padding: 14px 16px; border-radius: 12px;
          border: 1px solid #d2d2d7; background: #fff;
          font-family: inherit; font-size: 14px; color: #1d1d1f;
          outline: none; resize: vertical; min-height: 120px;
          transition: border-color .2s, box-shadow .2s;
          line-height: 1.5;
        }
        .cp-textarea:focus { border-color: #007aff; box-shadow: 0 0 0 3px rgba(0,122,255,.12); }
        .cp-select {
          width: 100%; padding: 12px 16px; border-radius: 12px;
          border: 1px solid #d2d2d7; background: #fff;
          font-family: inherit; font-size: 15px; color: #1d1d1f;
          outline: none; cursor: pointer; appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%2386868b' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 16px center;
          padding-right: 40px;
        }
        .cp-select:focus { border-color: #007aff; box-shadow: 0 0 0 3px rgba(0,122,255,.12); }

        /* Radio cards */
        .cp-radio-row {
          display: flex; gap: 12px;
        }
        .cp-radio-card {
          flex: 1; padding: 16px; border-radius: 12px;
          border: 2px solid #e5e5ea; background: #fff;
          cursor: pointer; transition: all .15s;
          text-align: center;
        }
        .cp-radio-card:hover { border-color: #bbb; }
        .cp-radio-card.selected { border-color: #007aff; background: #f0f5ff; }
        .cp-radio-card-label {
          font-size: 14px; font-weight: 600; color: #1d1d1f;
        }
        .cp-radio-card-desc {
          font-size: 12px; color: #86868b; margin-top: 4px;
        }

        /* Template card in wizard */
        .cp-tpl-list { display: flex; flex-direction: column; gap: 8px; max-height: 260px; overflow-y: auto; }
        .cp-tpl-item {
          padding: 14px 16px; border-radius: 12px;
          border: 2px solid #e5e5ea; background: #fff;
          cursor: pointer; transition: all .15s; text-align: left;
        }
        .cp-tpl-item:hover { border-color: #bbb; }
        .cp-tpl-item.selected { border-color: #007aff; background: #f0f5ff; }
        .cp-tpl-name { font-size: 14px; font-weight: 600; color: #1d1d1f; }
        .cp-tpl-body {
          font-size: 12.5px; color: #86868b; margin-top: 4px;
          line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2;
          -webkit-box-orient: vertical; overflow: hidden;
        }
        .cp-tpl-badge {
          display: inline-block; padding: 2px 8px; border-radius: 4px;
          font-size: 10px; font-weight: 700; text-transform: uppercase;
          letter-spacing: .5px; margin-top: 6px;
        }

        /* Footer buttons in modal */
        .cp-modal-footer {
          display: flex; align-items: center; justify-content: space-between;
          padding: 16px 28px 24px; border-top: 1px solid #f2f2f7;
        }

        /* Audience cards */
        .cp-aud-grid {
          display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 14px;
        }
        .cp-aud-card {
          background: #fff; border-radius: 16px;
          padding: 22px; cursor: default;
          border: 1px solid rgba(0,0,0,.04);
          transition: all .2s;
          display: flex; align-items: flex-start; gap: 16px;
        }
        .cp-aud-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(0,0,0,.06);
        }
        .cp-aud-dot {
          width: 40px; height: 40px; border-radius: 12px;
          display: flex; align-items: center; justify-content: center;
          font-size: 18px; font-weight: 700; color: #fff;
          flex-shrink: 0;
        }
        .cp-aud-info { flex: 1; min-width: 0; }
        .cp-aud-name {
          font-size: 15px; font-weight: 600; color: #1d1d1f;
          letter-spacing: -.1px;
        }
        .cp-aud-count {
          font-size: 24px; font-weight: 700; color: #1d1d1f;
          letter-spacing: -.3px; margin-top: 2px;
        }
        .cp-aud-desc {
          font-size: 12px; color: #aeaeb2; margin-top: 4px;
          line-height: 1.3;
        }
        .cp-aud-type {
          display: inline-block; padding: 2px 8px; border-radius: 6px;
          font-size: 10px; font-weight: 600; text-transform: uppercase;
          letter-spacing: .5px; margin-top: 8px;
        }

        /* Import zone */
        .cp-drop-zone {
          border: 2px dashed #d2d2d7; border-radius: 16px;
          padding: 48px 32px; text-align: center;
          transition: all .2s; cursor: pointer;
          background: #fafafa;
        }
        .cp-drop-zone:hover { border-color: #007aff; background: #f0f5ff; }
        .cp-drop-zone.has-file { border-color: #34c759; border-style: solid; background: #f0faf0; }
        .cp-drop-title {
          font-size: 17px; font-weight: 600; color: #1d1d1f;
          margin-top: 16px;
        }
        .cp-drop-desc {
          font-size: 13px; color: #86868b; margin-top: 6px;
        }

        /* Preview table */
        .cp-preview-table {
          width: 100%; border-collapse: separate; border-spacing: 0;
          font-size: 12px; margin-top: 16px; border-radius: 12px;
          overflow: hidden; border: 1px solid #e5e5ea;
        }
        .cp-preview-table th {
          background: #f9f9fb; padding: 10px 14px;
          text-align: left; font-weight: 600; color: #1d1d1f;
          border-bottom: 1px solid #e5e5ea;
        }
        .cp-preview-table td {
          padding: 10px 14px; color: #424245;
          border-bottom: 1px solid #f2f2f7;
        }

        /* Template cards in Templates tab */
        .cp-tpl-grid {
          display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 14px;
        }
        .cp-tpl-card {
          background: #fff; border-radius: 16px;
          padding: 22px; border: 1px solid rgba(0,0,0,.04);
          transition: all .2s;
        }
        .cp-tpl-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(0,0,0,.06);
        }

        /* Detail panel */
        .cp-detail-metrics {
          display: grid; grid-template-columns: repeat(5,1fr); gap: 12px;
          margin: 24px 0;
        }
        .cp-detail-metric {
          text-align: center; padding: 18px 8px;
          background: #f9f9fb; border-radius: 14px;
        }
        .cp-detail-metric-val {
          font-size: 26px; font-weight: 700; color: #1d1d1f;
          letter-spacing: -.3px;
        }
        .cp-detail-metric-lbl {
          font-size: 12px; color: #86868b; margin-top: 4px;
          font-weight: 500;
        }
        .cp-detail-bar-track {
          height: 8px; background: #f2f2f7; border-radius: 4px;
          overflow: hidden; margin: 8px 0;
        }
        .cp-detail-bar-fill {
          height: 100%; border-radius: 4px;
          transition: width .8s cubic-bezier(.4,0,.2,1);
        }

        /* Color picker grid */
        .cp-colors { display: flex; gap: 8px; flex-wrap: wrap; }
        .cp-color-dot {
          width: 32px; height: 32px; border-radius: 50%;
          border: 3px solid transparent; cursor: pointer;
          transition: all .15s;
        }
        .cp-color-dot:hover { transform: scale(1.15); }
        .cp-color-dot.active { border-color: #1d1d1f; }

        /* Empty state */
        .cp-empty {
          text-align: center; padding: 60px 20px;
        }
        .cp-empty-icon {
          width: 64px; height: 64px; border-radius: 20px;
          background: #f2f2f7; margin: 0 auto 20px;
          display: flex; align-items: center; justify-content: center;
        }
        .cp-empty-title {
          font-size: 20px; font-weight: 600; color: #1d1d1f;
          letter-spacing: -.2px;
        }
        .cp-empty-desc {
          font-size: 14px; color: #86868b; margin-top: 8px;
          max-width: 360px; margin-left: auto; margin-right: auto;
          line-height: 1.5;
        }

        /* Animations */
        @keyframes cpFadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes cpSlideUp {
          from { opacity: 0; transform: translateY(20px) scale(.97); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes cpCardIn {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Responsive */
        @media (max-width: 900px) {
          .cp-root { padding: 20px 16px 40px; }
          .cp-kpis { grid-template-columns: repeat(2, 1fr); }
          .cp-grid { grid-template-columns: 1fr; }
          .cp-detail-metrics { grid-template-columns: repeat(3,1fr); }
          .cp-header { flex-direction: column; align-items: flex-start; gap: 16px; }
          .cp-type-grid { grid-template-columns: 1fr !important; }
          .cp-aud-grid { grid-template-columns: 1fr; }
        }
        @media (max-width: 600px) {
          .cp-kpis { grid-template-columns: 1fr; }
          .cp-detail-metrics { grid-template-columns: repeat(2,1fr); }
          .cp-title { font-size: 28px; }
        }

        /* ══ Línea sobria (parte 1: pantalla principal) ══ */
        @keyframes cpx-up{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}
        .cpx-head{display:flex;justify-content:space-between;align-items:flex-end;gap:16px;margin-bottom:18px;animation:cpx-up .35s ease-out both;}
        .cpx-title{font-size:26px;font-weight:600;color:#111;letter-spacing:-0.6px;margin:0;}
        .cpx-sub{font-size:13px;color:#6B7280;margin:4px 0 0;font-weight:400;}
        .cpx-btn{display:inline-flex;align-items:center;gap:7px;height:36px;padding:0 14px;border-radius:6px;border:1px solid #E6E6E6;background:#fff;color:#111;font-size:13px;font-weight:400;font-family:inherit;cursor:pointer;transition:background .15s,transform .15s;white-space:nowrap;}
        .cpx-btn:hover{background:#F7F7F7;transform:translateY(-1px);} .cpx-btn:active{transform:scale(.97);}
        .cpx-btn--pri{background:#111;color:#fff;border-color:#111;} .cpx-btn--pri:hover{background:#2a2a2a;}
        .cpx-tabs{display:flex;gap:2px;border-bottom:1px solid #EFEFEF;margin-bottom:18px;overflow-x:auto;}
        .cpx-tab{height:38px;padding:0 12px;border:none;background:none;border-bottom:2px solid transparent;margin-bottom:-1px;font-size:13px;font-family:inherit;color:#6B7280;cursor:pointer;white-space:nowrap;display:flex;align-items:center;gap:6px;transition:color .15s,border-color .25s,background .15s;border-radius:6px 6px 0 0;}
        .cpx-tab:hover{color:#111;background:#FAFAFA;} .cpx-tab.on{color:#111;border-bottom-color:#111;}
        .cpx-tab-n{font-size:11px;color:#9CA3AF;font-variant-numeric:tabular-nums;} .cpx-tab.on .cpx-tab-n{color:#111;}
        .cpx-kpis{display:grid;grid-template-columns:repeat(4,1fr);background:#F7F7F7;border-radius:8px;margin-bottom:16px;}
        .cpx-kpi{padding:14px 18px;position:relative;animation:cpx-up .4s ease-out both;}
        .cpx-kpi+.cpx-kpi::before{content:'';position:absolute;left:0;top:14px;bottom:14px;width:1px;background:#E6E6E6;}
        .cpx-kpi small{display:block;font-size:12px;color:#6B7280;}
        .cpx-kpi b{display:block;font-size:22px;font-weight:500;color:#111;margin-top:4px;font-variant-numeric:tabular-nums;letter-spacing:-0.4px;}
        .cpx-bar{display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:14px;}
        .cpx-search{display:flex;align-items:center;gap:8px;background:#F4F4F4;border:1px solid transparent;border-radius:6px;padding:0 11px;height:34px;flex:1;min-width:200px;max-width:320px;transition:border-color .15s,background .15s;}
        .cpx-search:focus-within{background:#fff;border-color:#111;}
        .cpx-search input{border:none;background:none;outline:none;font-size:13px;font-family:inherit;width:100%;color:#111;}
        .cpx-chip{height:34px;padding:0 12px;border-radius:6px;border:1px solid #E6E6E6;background:#fff;font-size:12.5px;color:#374151;font-family:inherit;cursor:pointer;transition:background .15s;}
        .cpx-chip:hover{background:#F7F7F7;} .cpx-chip.on{background:#111;border-color:#111;color:#fff;}
        .cpx-table{border:1px solid #EFEFEF;border-radius:8px;overflow:hidden;}
        .cpx-row{display:grid;grid-template-columns:minmax(0,2.2fr) 1fr minmax(0,1.4fr) .8fr .7fr .7fr 1.2fr;gap:10px;align-items:center;padding:11px 16px;border-top:1px solid #F3F3F3;font-size:13px;color:#111;cursor:pointer;transition:background .15s;animation:cpx-up .3s ease-out both;}
        .cpx-row:hover{background:#FAFAFA;}
        .cpx-row--h{background:#FAFAFA;border-top:none;font-size:11.5px;color:#6B7280;cursor:default;animation:none;padding:9px 16px;}
        .cpx-row--h:hover{background:#FAFAFA;}
        .cpx-row .r{text-align:right;font-variant-numeric:tabular-nums;}
        .cpx-name{display:flex;align-items:center;gap:10px;min-width:0;}
        .cpx-ch{width:28px;height:28px;border-radius:6px;border:1px solid #EFEFEF;display:flex;align-items:center;justify-content:center;flex-shrink:0;background:#fff;}
        .cpx-n{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
        .cpx-st{display:inline-flex;align-items:center;gap:6px;font-size:12.5px;color:#374151;}
        .cpx-dot{width:6px;height:6px;border-radius:50%;flex-shrink:0;}
        .cpx-muted{color:#6B7280;font-size:12.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
        .cpx-fail{font-size:11.5px;color:#B42318;}
        .cpx-empty{border:1px dashed #E3E3E3;border-radius:8px;padding:40px 20px;text-align:center;}
        .cpx-empty-t{font-size:15px;color:#111;}
        @media (max-width:900px){.cpx-kpis{grid-template-columns:repeat(2,1fr);}.cpx-kpi:nth-child(3)::before{display:none;}.cpx-row{grid-template-columns:minmax(0,2fr) 1fr .8fr;}.cpx-row>div:nth-child(3),.cpx-row>div:nth-child(5),.cpx-row>div:nth-child(6),.cpx-row>div:nth-child(7){display:none;}}

        /* ══ Parte 2: asistente de creación ══ */
        .cpw-ov{position:fixed;inset:0;background:rgba(17,17,17,0.32);z-index:1000;display:flex;align-items:center;justify-content:center;padding:24px 16px;animation:cpx-fade .2s ease-out;}
        @keyframes cpx-fade{from{opacity:0}to{opacity:1}}
        .cpw{background:#fff;border-radius:10px;width:min(760px,100%);max-height:calc(var(--vh, 100vh) - 48px);display:flex;flex-direction:column;overflow:hidden;box-shadow:0 24px 64px rgba(0,0,0,0.16),0 0 0 1px rgba(0,0,0,0.04);animation:cpx-up .3s cubic-bezier(0.32,0.72,0,1);font-family:inherit;}
        .cpw-h{display:flex;justify-content:space-between;align-items:flex-start;padding:18px 22px 12px;}
        .cpw-t{font-size:17px;font-weight:600;color:#111;}
        .cpw-x{width:30px;height:30px;border-radius:6px;border:1px solid #E6E6E6;background:#fff;cursor:pointer;color:#6B7280;font-size:16px;line-height:1;}
        .cpw-x:hover{background:#F4F4F4;}
        .cpw-steps{display:flex;gap:4px;padding:0 22px 12px;border-bottom:1px solid #EFEFEF;overflow-x:auto;}
        .cpw-step{display:flex;align-items:center;gap:6px;font-size:12.5px;color:#9CA3AF;white-space:nowrap;padding:4px 8px 4px 0;}
        .cpw-step span{width:20px;height:20px;border-radius:50%;border:1px solid #E3E3E3;display:flex;align-items:center;justify-content:center;font-size:11px;}
        .cpw-step.on{color:#111;} .cpw-step.on span{background:#111;border-color:#111;color:#fff;}
        .cpw-step.done{color:#374151;} .cpw-step.done span{background:#F4F4F4;color:#111;}
        .cpw-b{padding:18px 22px;overflow-y:auto;min-height:0;flex:1;}
        .cpw-f2{display:flex;justify-content:space-between;gap:8px;padding:12px 22px;border-top:1px solid #EFEFEF;}
        .cpw-lbl{font-size:13px;color:#111;margin-bottom:10px;}
        .cpw-grid3{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;}
        .cpw-grid2{display:grid;grid-template-columns:repeat(2,1fr);gap:10px;}
        .cpw-opt{display:flex;flex-direction:column;align-items:flex-start;gap:8px;padding:14px;border:1px solid #EFEFEF;border-radius:8px;background:#fff;font-family:inherit;cursor:pointer;text-align:left;transition:border-color .15s,background .15s,transform .15s;}
        .cpw-opt:hover:not(:disabled){border-color:#D6D6D6;transform:translateY(-1px);}
        .cpw-opt.on{border-color:#111;background:#FAFAFA;}
        .cpw-opt:disabled{opacity:.5;cursor:not-allowed;}
        .cpw-opt--row{flex-direction:row;align-items:center;gap:10px;}
        .cpw-opt-n{font-size:14px;color:#111;}
        .cpw-radio{width:16px;height:16px;border-radius:50%;border:1.5px solid #CFCFCF;flex-shrink:0;position:relative;}
        .on>.cpw-radio{border-color:#111;} .on>.cpw-radio::after{content:'';position:absolute;inset:3px;border-radius:50%;background:#111;}
        .cpw-f{display:flex;flex-direction:column;gap:6px;font-size:13px;color:#111;}
        .cpw-f input,.cpw-f textarea{border:1px solid #E3E3E3;border-radius:6px;padding:0 11px;height:36px;font-size:13px;font-family:inherit;color:#111;outline:none;transition:border-color .15s;}
        .cpw-f textarea{height:auto;padding:9px 11px;resize:vertical;line-height:1.5;}
        .cpw-f input:focus,.cpw-f textarea:focus{border-color:#111;}
        .cpw-f small{font-size:12px;color:#6B7280;}
        .cpw-list{display:flex;flex-direction:column;border:1px solid #EFEFEF;border-radius:8px;overflow:hidden;max-height:320px;overflow-y:auto;}
        .cpw-row{display:flex;align-items:center;gap:12px;padding:11px 14px;border:none;border-top:1px solid #F3F3F3;background:#fff;font-family:inherit;font-size:13px;color:#111;cursor:pointer;transition:background .15s;}
        .cpw-row:first-child{border-top:none;} .cpw-row:hover{background:#FAFAFA;} .cpw-row.on{background:#F5F5F5;}
        .cpw-link{margin-top:10px;border:none;background:none;padding:0;font:inherit;font-size:13px;color:#111;text-decoration:underline;text-underline-offset:2px;cursor:pointer;}
        .cpw-tpls{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;max-height:380px;overflow-y:auto;padding:2px;}
        .cpw-tpl{display:flex;flex-direction:column;gap:8px;padding:12px;border:1px solid #EFEFEF;border-radius:8px;background:#fff;font-family:inherit;text-align:left;cursor:pointer;transition:border-color .15s;}
        .cpw-tpl:hover{border-color:#D6D6D6;} .cpw-tpl.on{border-color:#111;box-shadow:0 0 0 1px #111;}
        .cpw-tpl-h{display:flex;justify-content:space-between;gap:8px;font-size:13px;color:#111;}
        .cpw-bub{background:#F3F7F2;border-radius:2px 8px 8px 8px;padding:9px 11px;font-size:12.5px;color:#111;line-height:1.5;display:flex;flex-direction:column;gap:4px;max-height:160px;overflow:hidden;}
        .cpw-media{font-size:11.5px;color:#6B7280;background:#E9EEE8;border-radius:4px;padding:10px;text-align:center;}
        .cpw-var{background:#E8EEF9;color:#1d4ed8;border-radius:3px;padding:0 3px;font-family:ui-monospace,Menlo,monospace;font-size:.92em;}
        .cpw-note{margin-top:12px;font-size:12.5px;color:#374151;background:#F4F4F4;border-radius:6px;padding:8px 10px;line-height:1.5;}
        .cpw-err{margin-top:12px;font-size:12.5px;color:#B42318;background:#FEF5F5;border:1px solid #F5DADA;border-radius:6px;padding:8px 10px;}
        .cpw-sum{margin-top:14px;border:1px solid #EFEFEF;border-radius:8px;padding:12px 14px;}
        .cpw-sr{display:flex;justify-content:space-between;gap:12px;padding:6px 0;border-top:1px solid #F3F3F3;font-size:13px;}
        .cpw-sr:first-of-type{border-top:none;} .cpw-sr span{color:#6B7280;} .cpw-sr b{font-weight:400;color:#111;text-align:right;}
        @media (max-width:700px){.cpw-grid3,.cpw-tpls{grid-template-columns:1fr;}}

        /* ══ Parte 3: detalle de campaña ══ */
        .cpd-meta{display:flex;flex-wrap:wrap;gap:12px;font-size:12.5px;color:#6B7280;margin-top:5px;}
        .cpd-grid{display:grid;grid-template-columns:minmax(0,1.4fr) minmax(0,1fr);gap:12px;}
        .cpd-card{border:1px solid #EFEFEF;border-radius:8px;padding:14px;}
        .cpd-lh{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;}
        .cpd-row{display:grid;grid-template-columns:1fr .8fr minmax(0,1.6fr) .9fr;gap:10px;align-items:center;padding:9px 14px;border-top:1px solid #F3F3F3;font-size:13px;color:#111;}
        .cpd-row.cpx-row--h{border-top:none;background:#FAFAFA;font-size:11.5px;color:#6B7280;}
        @media (max-width:700px){.cpd-grid{grid-template-columns:1fr;}.cpd-row{grid-template-columns:1fr .8fr .9fr;}.cpd-row>div:nth-child(3){display:none;}}
      `}</style>

      <div className="cp-root">
        {/* ══════ ENCABEZADO ══════ */}
        <div className="cpx-head">
          <div>
            <h1 className="cpx-title">Campañas</h1>
            <p className="cpx-sub">Mensajes masivos a tus audiencias, con plantillas aprobadas por Meta</p>
          </div>
          <button className="cpx-btn cpx-btn--pri" onClick={() => setShowCreate(true)}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Nueva campaña
          </button>
        </div>

        {/* ══════ PESTAÑAS ══════ */}
        <div className="cpx-tabs">
          {TABS.map(t => {
            const n = t.id === 'campaigns' ? campaigns.length : t.id === 'audiences' ? audiences.length : templates.length;
            return (
              <button key={t.id} className={`cpx-tab${tab === t.id ? ' on' : ''}`} onClick={() => setTab(t.id)}>
                {t.label}<span className="cpx-tab-n">{fmtN(n)}</span>
              </button>
            );
          })}
        </div>

        {/* ══════ TAB: CAMPAÑAS ══════ */}
        {tab === 'campaigns' && <>
          <div className="cpx-kpis">
            {[
              ['Mensajes enviados', fmtN(totalSent)],
              ['Tasa de entrega · WhatsApp', fmtPct(deliveryRate)],
              ['Tasa de lectura · WhatsApp', fmtPct(openRate)],
              ['Fallidos', fmtN(totalFailed)],
            ].map(([l,v],i) => (
              <div key={l} className="cpx-kpi" style={{ animationDelay:`${i*40}ms` }}><small>{l}</small><b>{v}</b></div>
            ))}
          </div>

          <div className="cpx-bar">
            <div className="cpx-search">
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="5" stroke="#9CA3AF" strokeWidth="1.5"/><path d="M11 11l3 3" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round"/></svg>
              <input placeholder="Buscar campaña…" value={searchQ} onChange={e => setSearchQ(e.target.value)} />
            </div>
            {FILTERS.map(f => (
              <button key={f.id} className={`cpx-chip${filter === f.id ? ' on' : ''}`} onClick={() => setFilter(f.id)}>{f.label}</button>
            ))}
          </div>

          {filtered.length === 0 ? (
            <div className="cpx-empty">
              <div className="cpx-empty-t">{campaigns.length ? 'Ninguna campaña coincide con la búsqueda' : 'Aún no tienes campañas'}</div>
              <div className="cpx-sub" style={{ marginTop:4 }}>{campaigns.length ? 'Prueba con otro filtro.' : 'Envía una plantilla aprobada a una de tus audiencias.'}</div>
              {!campaigns.length && <button className="cpx-btn cpx-btn--pri" style={{ marginTop:14 }} onClick={() => setShowCreate(true)}>Crear campaña</button>}
            </div>
          ) : (
            <div className="cpx-table">
              <div className="cpx-row cpx-row--h">
                <div>Campaña</div><div>Estado</div><div>Audiencia</div><div className="r">Enviados</div><div className="r">Entrega</div><div className="r">Lectura</div><div>Fecha</div>
              </div>
              {filtered.map((c, idx) => {
                const st = STATUS_MAP[c.status] || STATUS_MAP.draft;
                const m = c.metrics || {};
                const isWa = c.type === 'whatsapp';
                const pct = (a, b) => b > 0 ? fmtPct((a / b) * 100) : '—';
                const when = c.sentAt ? fmtDate(c.sentAt) : c.scheduledAt ? `Programada · ${fmtDate(c.scheduledAt)}` : 'Sin enviar';
                return (
                  <div key={c.id} className="cpx-row" style={{ animationDelay: `${Math.min(idx, 12) * 25}ms` }} onClick={() => setShowDetail(c.id)}>
                    <div className="cpx-name">
                      <span className="cpx-ch">{TYPE_ICONS[c.type]?.(14)}</span>
                      <div style={{ minWidth:0 }}>
                        <div className="cpx-n">{c.name}</div>
                        <div className="cpx-sub" style={{ fontSize:12 }}>{TYPE_LABELS[c.type] || c.type}{isWa && c.template ? ` · ${c.template}` : ''}</div>
                      </div>
                    </div>
                    <div><span className="cpx-st"><span className="cpx-dot" style={{ background: st.color }}/>{st.label}</span></div>
                    <div className="cpx-muted">{c.audience || '—'}{c.audienceCount > 0 ? ` · ${fmtN(c.audienceCount)}` : ''}</div>
                    <div className="r">{fmtN(m.sent || 0)}{m.failed > 0 && <div className="cpx-fail">{fmtN(m.failed)} fallidos</div>}</div>
                    <div className="r">{isWa ? pct(m.delivered || 0, m.sent || 0) : '—'}</div>
                    <div className="r">{isWa ? pct(m.read || 0, m.delivered || 0) : '—'}</div>
                    <div className="cpx-muted">{when}</div>
                  </div>
                );
              })}
            </div>
          )}
        </>}

        {/* ══════════════════════════════════════════ */}
        {/* ══════ TAB: AUDIENCIAS ══════ */}
        {/* ══════════════════════════════════════════ */}
        {tab === 'audiences' && <>
          <div style={{ display:'flex', gap:10, marginBottom:24, flexWrap:'wrap' }}>
            <button className="cp-btn-primary" onClick={() => setShowImport(true)}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
              Importar contactos
            </button>
            <button className="cp-btn-secondary" onClick={() => setShowNewList(true)}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Nueva lista
            </button>
          </div>

          <div className="cp-aud-grid">
            {audiences.map((a, idx) => (
              <div key={a.id} className="cp-aud-card" style={{ animation: `cpCardIn .4s cubic-bezier(.4,0,.2,1) ${idx * .05}s both` }}>
                <div className="cp-aud-dot" style={{ background: a.color }}>
                  {a.type === 'auto' ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                  ) : a.type === 'segment' ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 2a15 15 0 0 0 0 20M12 2a15 15 0 0 1 0 20M2 12h20"/></svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
                  )}
                </div>
                <div className="cp-aud-info">
                  <div className="cp-aud-name">{a.name}</div>
                  <div className="cp-aud-count">{fmtN(a.count)} contactos</div>
                  <div className="cp-aud-desc">{a.desc}</div>
                  <div style={{ display:'flex', gap:6, marginTop:8 }}>
                    <span className="cp-aud-type" style={{
                      color: a.type === 'auto' ? '#007aff' : a.type === 'segment' ? '#af52de' : '#34c759',
                      background: a.type === 'auto' ? '#e8f0fe' : a.type === 'segment' ? '#f5eeff' : '#e8f5e9',
                    }}>
                      {a.type === 'auto' ? 'Automática' : a.type === 'segment' ? 'Segmento' : 'Lista'}
                    </span>
                    <button
                      style={{ padding:'3px 10px', fontSize:11, fontWeight:600, fontFamily:SF, border:'1px solid #e5e5ea', borderRadius:6, background:'#fff', color:'#007aff', cursor:'pointer' }}
                      onClick={(e) => { e.stopPropagation(); setShowAddContact(a.id); setAcPhone(''); setAcName(''); }}
                    >+ Agregar</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>}

        {/* ══════════════════════════════════════════ */}
        {/* ══════ TAB: PLANTILLAS ══════ */}
        {/* ══════════════════════════════════════════ */}
        {tab === 'templates' && <>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24, flexWrap:'wrap', gap:12 }}>
            <p style={{ fontSize:14, color:'#86868b', margin:0 }}>
              Tus plantillas de WhatsApp aprobadas por Meta. Se crean en Configuración → Plantillas.
            </p>
            <button className="cp-btn-primary" onClick={openTplCreator}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Crear plantilla
            </button>
          </div>
          {templates.length === 0 ? (
            <div className="cp-empty">
              <div className="cp-empty-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#aeaeb2" strokeWidth="1.5" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
              </div>
              <div className="cp-empty-title">Sin plantillas</div>
              <div className="cp-empty-desc">Crea tu primera plantilla de WhatsApp. Meta la revisará y aprobará (toma entre 1 minuto y 24 horas).</div>
              <button className="cp-btn-primary" style={{ marginTop:24 }} onClick={openTplCreator}>Crear plantilla</button>
            </div>
          ) : (
            <div className="cp-tpl-grid">
              {templates.map((t, idx) => {
                const statusMap = {
                  APPROVED: { label:'Aprobada', color:'#34c759', bg:'#e8f5e9' },
                  PENDING: { label:'En revisión', color:'#ff9500', bg:'#fff3e0' },
                  REJECTED: { label:'Rechazada', color:'#ff3b30', bg:'#ffeaea' },
                  PAUSED: { label:'Pausada', color:'#8e8e93', bg:'#f2f2f7' },
                  DISABLED: { label:'Desactivada', color:'#8e8e93', bg:'#f2f2f7' },
                };
                const st = statusMap[t.status] || { label:t.status, color:'#8e8e93', bg:'#f2f2f7' };
                return (
                  <div key={t.id} className="cp-tpl-card" style={{ animation: `cpCardIn .4s cubic-bezier(.4,0,.2,1) ${idx * .05}s both` }}>
                    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 }}>
                      <span className="cp-card-type">
                        {TYPE_ICONS.whatsapp(14)}
                        WhatsApp
                      </span>
                      <span className="cp-tpl-badge" style={{ color:st.color, background:st.bg }}>{st.label}</span>
                    </div>
                    <div style={{ fontSize:16, fontWeight:600, color:'#1d1d1f', marginBottom:6 }}>{t.name}</div>
                    {t.header && t.header.format === 'TEXT' && (
                      <div style={{ fontSize:12, color:'#007aff', fontWeight:600, marginBottom:4 }}>{t.header.text}</div>
                    )}
                    {t.header && t.header.format && t.header.format !== 'TEXT' && (
                      <div style={{ fontSize:11, color:'#86868b', background:'#f2f2f7', display:'inline-flex', alignItems:'center', gap:4, padding:'2px 8px', borderRadius:6, marginBottom:6, fontWeight:500 }}>
                        {t.header.format === 'IMAGE' ? '🖼' : t.header.format === 'VIDEO' ? '🎬' : '📄'} {t.header.format}
                      </div>
                    )}
                    <div style={{ fontSize:13, color:'#86868b', lineHeight:1.5 }}>{t.body}</div>
                    {t.footer && <div style={{ fontSize:12, color:'#aeaeb2', marginTop:6, fontStyle:'italic' }}>{t.footer}</div>}
                    {t.buttons && t.buttons.length > 0 && (
                      <div style={{ display:'flex', gap:6, marginTop:10, flexWrap:'wrap' }}>
                        {t.buttons.map((b, bi) => (
                          <span key={bi} style={{ fontSize:11, color:'#007aff', background:'#e8f0fe', padding:'4px 10px', borderRadius:8, fontWeight:500 }}>
                            {b.text}
                          </span>
                        ))}
                      </div>
                    )}
                    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:14 }}>
                      <div style={{ display:'flex', gap:8 }}>
                        <span style={{ fontSize:11, color:'#aeaeb2', background:'#f2f2f7', padding:'3px 10px', borderRadius:6, fontWeight:500 }}>
                          {t.category}
                        </span>
                        <span style={{ fontSize:11, color:'#aeaeb2', background:'#f2f2f7', padding:'3px 10px', borderRadius:6, fontWeight:500 }}>
                          {t.lang.toUpperCase()}
                        </span>
                      </div>
                      <button
                        onClick={() => handleDeleteTemplate(t.name)}
                        disabled={tplDeleting === t.name}
                        style={{
                          background:'none', border:'none', cursor:'pointer', padding:'4px 8px',
                          borderRadius:8, color:'#ff3b30', fontSize:12, fontWeight:500,
                          opacity: tplDeleting === t.name ? .4 : .6,
                          transition:'all .15s', fontFamily:'inherit',
                        }}
                        onMouseEnter={e => e.target.style.opacity = '1'}
                        onMouseLeave={e => e.target.style.opacity = '.6'}
                      >
                        {tplDeleting === t.name ? 'Eliminando...' : 'Eliminar'}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>}
      </div>

      {/* ══════════════════════════════════════════════════════ */}
      {/* ══════ MODAL: CREAR CAMPAÑA ══════ */}
      {/* ══════════════════════════════════════════════════════ */}
      {showCreate && (() => {
        const STEPS = ['Canal','Nombre','Audiencia', cType === 'whatsapp' ? 'Plantilla' : 'Mensaje','Envío'];
        const aud = audiences.find(a => a.id === parseInt(cAudience));
        const approved = templates.filter(t => t.status === 'APPROVED');
        const q = (cTplQ || '').trim().toLowerCase();
        const tplList = approved.filter(t => !q || t.name.toLowerCase().includes(q) || (t.body || '').toLowerCase().includes(q))
          .sort((a,b) => (a.category === 'MARKETING' ? 0 : 1) - (b.category === 'MARKETING' ? 0 : 1));
        const selTpl = templates.find(t => t.name === cTemplate);
        const nowLocal = new Date();
        const pastDate = cSchedule === 'later' && cDate && new Date(`${cDate}T${cTime || '00:00'}:00-05:00`) <= nowLocal;
        const blocked = (cStep === 0 && !cType) || (cStep === 1 && !cName.trim()) || (cStep === 2 && !cAudience)
          || (cStep === 3 && cType === 'whatsapp' && !cTemplate) || (cStep === 3 && cType === 'email' && (!cSubject.trim() || !cBody.trim()))
          || (cStep === 3 && cType === 'sms' && !cBody.trim()) || (cStep === 4 && cSchedule === 'later' && (!cDate || pastDate));
        const hl = (txt) => String(txt || '').split(/(\{\{\d+\}\})/g).map((p,i) => /^\{\{\d+\}\}$/.test(p) ? <span key={i} className="cpw-var">{p}</span> : p);
        return (
        <CpPortal><div className="cpw-ov" onClick={e => { if (e.target === e.currentTarget && !cSaving) resetCreate(); }}>
          <div className="cpw">
            <div className="cpw-h">
              <div><div className="cpw-t">Nueva campaña</div><div className="cpx-sub">Paso {cStep + 1} de 5 · {STEPS[cStep]}</div></div>
              <button className="cpw-x" onClick={resetCreate}>×</button>
            </div>
            <div className="cpw-steps">
              {STEPS.map((s,i) => <div key={i} className={`cpw-step${cStep === i ? ' on' : cStep > i ? ' done' : ''}`}><span>{cStep > i ? '✓' : i + 1}</span>{s}</div>)}
            </div>

            <div className="cpw-b">
              {cStep === 0 && (
                <div className="cpw-grid3">
                  {[
                    { id:'whatsapp', name:'WhatsApp', desc:'Plantillas aprobadas por Meta, enviadas desde tu número' },
                    { id:'sms', name:'SMS', desc:'Mensajes de texto al celular' },
                    { id:'email', name:'Correo', desc:'Correos masivos con tus productos' },
                  ].map(t => {
                    const on = !!channels[t.id];
                    return (
                      <button key={t.id} className={`cpw-opt${cType === t.id ? ' on' : ''}`} disabled={!on} onClick={() => setCType(t.id)}>
                        <span className="cpx-ch" style={{ width:34, height:34 }}>{TYPE_ICONS[t.id](18)}</span>
                        <span className="cpw-opt-n">{t.name}</span>
                        <span className="cpx-sub" style={{ margin:0, fontSize:12.5 }}>{on ? t.desc : 'Próximamente para tu empresa'}</span>
                      </button>
                    );
                  })}
                </div>
              )}

              {cStep === 1 && (
                <label className="cpw-f">Nombre de la campaña
                  <input value={cName} onChange={e => setCName(e.target.value)} placeholder="Ej: Promo fin de mes" autoFocus maxLength={120}/>
                  <small>Solo lo ves tú, para identificarla en la lista.</small>
                </label>
              )}

              {cStep === 2 && (
                <div>
                  <div className="cpw-lbl">Elige a quién enviarla</div>
                  {audiences.length === 0 ? (
                    <div className="cpx-empty" style={{ padding:'24px 16px' }}>
                      <div className="cpx-empty-t">Aún no tienes audiencias</div>
                      <button className="cpx-btn" style={{ marginTop:10 }} onClick={() => { resetCreate(); setTab('audiences'); setShowImport(true); }}>Importar contactos</button>
                    </div>
                  ) : (
                    <div className="cpw-list">
                      {audiences.map(a => (
                        <button key={a.id} className={`cpw-row${String(cAudience) === String(a.id) ? ' on' : ''}`} onClick={() => setCAudience(String(a.id))}>
                          <span className="cpw-radio"/>
                          <span style={{ flex:1, textAlign:'left', minWidth:0 }}><span className="cpx-n" style={{ display:'block' }}>{a.name}</span>{a.description && <span className="cpx-sub" style={{ fontSize:12, margin:0 }}>{a.description}</span>}</span>
                          <span className="cpx-muted">{fmtN(a.count)} contactos</span>
                        </button>
                      ))}
                    </div>
                  )}
                  {audiences.length > 0 && <button className="cpw-link" onClick={() => { resetCreate(); setTab('audiences'); setShowImport(true); }}>o importar contactos nuevos</button>}
                </div>
              )}

              {cStep === 3 && cType === 'whatsapp' && (
                <div>
                  <div className="cpw-lbl">Elige la plantilla aprobada</div>
                  {approved.length === 0 ? (
                    <div className="cpx-empty" style={{ padding:'24px 16px' }}>
                      <div className="cpx-empty-t">No tienes plantillas aprobadas</div>
                      <div className="cpx-sub">Crea una y espera la aprobación de Meta.</div>
                      <button className="cpx-btn" style={{ marginTop:10 }} onClick={() => { resetCreate(); openTplCreator(); }}>Crear plantilla</button>
                    </div>
                  ) : (<>
                    <div className="cpx-search" style={{ maxWidth:'none', marginBottom:10 }}>
                      <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="5" stroke="#9CA3AF" strokeWidth="1.5"/><path d="M11 11l3 3" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round"/></svg>
                      <input placeholder="Buscar plantilla…" value={cTplQ} onChange={e => setCTplQ(e.target.value)}/>
                    </div>
                    <div className="cpw-tpls">
                      {tplList.map(t => (
                        <button key={t.id} className={`cpw-tpl${cTemplate === t.name ? ' on' : ''}`} onClick={() => setCTemplate(t.name)}>
                          <div className="cpw-tpl-h"><span className="cpx-n">{t.name}</span><span className="cpx-muted">{t.category === 'MARKETING' ? 'Marketing' : t.category === 'UTILITY' ? 'Utilidad' : t.category} · {t.lang}</span></div>
                          <div className="cpw-bub">
                            {t.header && t.header.format && t.header.format !== 'TEXT' && <div className="cpw-media">{({IMAGE:'Imagen',VIDEO:'Video',DOCUMENT:'Documento'})[t.header.format] || t.header.format}</div>}
                            {t.header && t.header.format === 'TEXT' && <div style={{ fontWeight:500 }}>{t.header.text}</div>}
                            <div style={{ whiteSpace:'pre-wrap' }}>{hl(t.body)}</div>
                            {t.footer && <div className="cpx-sub" style={{ fontSize:11.5 }}>{t.footer}</div>}
                          </div>
                        </button>
                      ))}
                      {tplList.length === 0 && <div className="cpx-sub">Ninguna plantilla coincide.</div>}
                    </div>
                    {selTpl && /\{\{\d+\}\}/.test(selTpl.body || '') && <div className="cpw-note">Las variables de la plantilla se llenan con el nombre de cada contacto.</div>}
                  </>)}
                </div>
              )}
              {cStep === 3 && cType === 'sms' && (
                <label className="cpw-f">Mensaje SMS
                  <textarea rows={5} value={cBody} onChange={e => setCBody(e.target.value)} maxLength={320} placeholder="Ej: Hola {{nombre}}, aprovecha 30% de descuento solo hoy."/>
                  <small>{cBody.length}/320 · {cBody.length > 160 ? '2 segmentos SMS' : '1 segmento SMS'} · <b>{'{{nombre}}'}</b> se reemplaza por el nombre de cada contacto.</small>
                </label>
              )}
              {cStep === 3 && cType === 'email' && (<>
                <label className="cpw-f">Asunto<input value={cSubject} onChange={e => setCSubject(e.target.value)} placeholder="Ej: No te pierdas nuestra nueva colección"/></label>
                <label className="cpw-f" style={{ marginTop:12 }}>Contenido<textarea rows={7} value={cBody} onChange={e => setCBody(e.target.value)} placeholder="Escribe el contenido del correo…"/></label>
              </>)}

              {cStep === 4 && (
                <div>
                  <div className="cpw-lbl">¿Cuándo enviarla?</div>
                  <div className="cpw-grid2">
                    {[['now','Ahora','Se empieza a enviar al confirmar'],['later','Programar','Elige fecha y hora (hora Colombia)']].map(([k,l,dsc]) => (
                      <button key={k} className={`cpw-opt cpw-opt--row${cSchedule === k ? ' on' : ''}`} onClick={() => setCSchedule(k)}><span className="cpw-radio"/><span style={{ textAlign:'left' }}><span className="cpw-opt-n" style={{ display:'block' }}>{l}</span><span className="cpx-sub" style={{ margin:0, fontSize:12.5 }}>{dsc}</span></span></button>
                    ))}
                  </div>
                  {cSchedule === 'later' && (
                    <div className="cpw-grid2" style={{ marginTop:12 }}>
                      <label className="cpw-f">Fecha<input type="date" value={cDate} min={new Date(Date.now() - 5*3600000).toISOString().slice(0,10)} onChange={e => setCDate(e.target.value)}/></label>
                      <label className="cpw-f">Hora<input type="time" value={cTime} onChange={e => setCTime(e.target.value)}/></label>
                    </div>
                  )}
                  {pastDate && <div className="cpw-err">La fecha y hora ya pasaron. Elige un momento futuro.</div>}
                  <div className="cpw-sum">
                    <div className="cpw-lbl" style={{ marginBottom:6 }}>Resumen</div>
                    {[['Canal', TYPE_LABELS[cType] || cType], ['Campaña', cName || '—'], ['Audiencia', aud ? `${aud.name} · ${fmtN(aud.count)} contactos` : '—'],
                      [cType === 'whatsapp' ? 'Plantilla' : cType === 'sms' ? 'Mensaje' : 'Asunto', cType === 'whatsapp' ? (cTemplate || '—') : cType === 'sms' ? ((cBody.slice(0,60) + (cBody.length > 60 ? '…' : '')) || '—') : (cSubject || '—')],
                      ['Envío', cSchedule === 'now' ? 'Inmediato' : (cDate ? `${cDate} a las ${cTime} (hora Colombia)` : '—')]].map(([l,v]) => (
                      <div key={l} className="cpw-sr"><span>{l}</span><b>{v}</b></div>
                    ))}
                  </div>
                  {cType === 'whatsapp' && aud && <div className="cpw-note">Meta cobra cada conversación que inicias con una plantilla. Esta campaña se enviará a {fmtN(aud.count)} contactos.</div>}
                </div>
              )}
              {cErr && <div className="cpw-err">{cErr}</div>}
            </div>

            <div className="cpw-f2">
              <button className="cpx-btn" onClick={() => cStep === 0 ? resetCreate() : setCStep(s => s - 1)} disabled={cSaving}>{cStep === 0 ? 'Cancelar' : 'Atrás'}</button>
              <button className="cpx-btn cpx-btn--pri" disabled={blocked || cSaving} onClick={() => { setCErr(''); if (cStep < 4) setCStep(s => s + 1); else handleCreateCampaign(); }}>
                {cSaving ? 'Creando…' : cStep === 4 ? (cSchedule === 'now' ? 'Enviar ahora' : 'Programar campaña') : 'Continuar'}
              </button>
            </div>
          </div>
        </div></CpPortal>
        );
      })()}

      {/* ══════════════════════════════════════════════════════ */}
      {/* ══════ MODAL: DETALLE CAMPAÑA ══════ */}
      {/* ══════════════════════════════════════════════════════ */}
      {detailCamp && (() => {
        const c = detailCamp; const m = c.metrics || {};
        const st = STATUS_MAP[c.status] || STATUS_MAP.draft;
        const isWa = c.type === 'whatsapp';
        const tpl = isWa ? templates.find(t => t.name === c.template) : null;
        const logs = (dLogs || []).filter(l => !dOnlyFailed || l.status === 'failed');
        const LOGST = { sent:{l:'Enviado',c:'#6B7280'}, delivered:{l:'Entregado',c:'#16a34a'}, read:{l:'Leído',c:'#1d4ed8'}, failed:{l:'Falló',c:'#dc2626'}, pending:{l:'Pendiente',c:'#9CA3AF'} };
        const fmtT = (d) => { if (!d) return '—'; try { return new Date(d).toLocaleString('es-CO', { day:'numeric', month:'short', hour:'2-digit', minute:'2-digit' }); } catch { return d; } };
        const canRetry = (c.status === 'sent' || c.status === 'failed') && (m.failed || 0) > 0;
        const close = () => { setShowDetail(null); setDLogs(null); setDOnlyFailed(false); setDMsg(''); };
        return (
        <CpPortal><div className="cpw-ov" onClick={e => { if (e.target === e.currentTarget) close(); }}>
          <div className="cpw" style={{ width:'min(860px,100%)' }}>
            <div className="cpw-h">
              <div style={{ minWidth:0 }}>
                <div className="cpw-t">{c.name}</div>
                <div className="cpd-meta">
                  <span className="cpx-st"><span className="cpx-dot" style={{ background:st.color }}/>{st.label}</span>
                  <span>{TYPE_LABELS[c.type] || c.type}</span>
                  {c.audience && <span>{c.audience}{c.audienceCount > 0 ? ` · ${fmtN(c.audienceCount)} contactos` : ''}</span>}
                  {c.sentAt && <span>Enviada {fmtT(c.sentAt)}</span>}
                  {!c.sentAt && c.scheduledAt && <span>Programada {fmtT(c.scheduledAt)}</span>}
                </div>
              </div>
              <button className="cpw-x" onClick={close}>×</button>
            </div>

            <div className="cpw-b">
              {(m.sent || 0) > 0 && (
                <div className="cpx-kpis" style={{ gridTemplateColumns:`repeat(${isWa ? 4 : 2},1fr)`, marginBottom:14 }}>
                  {[['Enviados', fmtN(m.sent)], ...(isWa ? [['Entregados', `${fmtN(m.delivered || 0)} · ${m.sent ? fmtPct((m.delivered||0)/m.sent*100) : '0%'}`], ['Leídos', `${fmtN(m.read || 0)} · ${m.delivered ? fmtPct((m.read||0)/m.delivered*100) : '0%'}`]] : []), ['Fallidos', fmtN(m.failed || 0)]]
                    .map(([l,v]) => <div key={l} className="cpx-kpi"><small>{l}</small><b style={{ fontSize:18 }}>{v}</b></div>)}
                </div>
              )}

              <div className="cpd-grid">
                <div className="cpd-card">
                  <div className="cpw-lbl">{isWa ? 'Plantilla enviada' : 'Mensaje enviado'}</div>
                  {isWa ? (
                    <div>
                      <div className="cpx-muted" style={{ marginBottom:6 }}>{c.template || '—'} · {c.templateLanguage || 'es'}</div>
                      {tpl ? <div className="cpw-bub" style={{ maxHeight:'none' }}>{tpl.header && tpl.header.format && tpl.header.format !== 'TEXT' && <div className="cpw-media">{({IMAGE:'Imagen',VIDEO:'Video',DOCUMENT:'Documento'})[tpl.header.format] || tpl.header.format}</div>}<div style={{ whiteSpace:'pre-wrap' }}>{tpl.body}</div>{tpl.footer && <div className="cpx-sub" style={{ fontSize:11.5 }}>{tpl.footer}</div>}</div>
                        : <div className="cpx-sub">La plantilla ya no está en tu cuenta de WhatsApp.</div>}
                    </div>
                  ) : (
                    <div className="cpw-bub" style={{ maxHeight:'none', background:'#F7F7F7' }}>{c.subject && <div style={{ fontWeight:500 }}>{c.subject}</div>}<div style={{ whiteSpace:'pre-wrap' }}>{c.body || '—'}</div></div>
                  )}
                </div>
                <div className="cpd-card">
                  <div className="cpw-lbl">Acciones</div>
                  {canRetry && (
                    <div style={{ marginBottom:10 }}>
                      <button className="cpx-btn cpx-btn--pri" disabled={dBusy} onClick={async () => {
                        const n = m.failed || 0;
                        if (!window.confirm(isWa ? `Se reenviará SOLO a los ${fmtN(n)} números que fallaron. ¿Continuar?` : `Atención: en ${TYPE_LABELS[c.type]} se reenvía a TODA la audiencia. ¿Continuar?`)) return;
                        setDBusy(true); setDMsg('');
                        try {
                          const r = await fetch(`${API}/campaigns/${c.id}/retry`, { method:'POST', headers:authH() });
                          const d = await r.json().catch(() => ({}));
                          if (r.ok) { if (d.campaign) setCampaigns(prev => prev.map(x => x.id === d.campaign.id ? { ...x, ...d.campaign } : x)); setDMsg(isWa ? `Reenviando a ${fmtN(d.retried || n)} números.` : 'Campaña reenviada.'); setDLogs(null); }
                          else setDMsg(typeof d.detail === 'string' ? d.detail : 'No se pudo reintentar');
                        } catch { setDMsg('Error de conexión'); }
                        setDBusy(false);
                      }}>{isWa ? `Reintentar ${fmtN(m.failed)} fallidos` : 'Reenviar campaña'}</button>
                      <div className="cpx-sub" style={{ fontSize:12 }}>{isWa ? 'Solo a los números que fallaron; quienes ya la recibieron no la reciben otra vez.' : 'Este canal reenvía a toda la audiencia.'}</div>
                    </div>
                  )}
                  {c.status !== 'sending' && (
                    <button className="cpx-btn" style={{ color:'#B42318', borderColor:'#F0DADA' }} disabled={dBusy} onClick={async () => {
                      if (!window.confirm(`¿Eliminar la campaña "${c.name}"? Se borra también su registro de envíos.`)) return;
                      setDBusy(true);
                      try {
                        const r = await fetch(`${API}/campaigns/${c.id}`, { method:'DELETE', headers:authH() });
                        const d = await r.json().catch(() => ({}));
                        if (r.ok) { setCampaigns(prev => prev.filter(x => x.id !== c.id)); close(); }
                        else setDMsg(typeof d.detail === 'string' ? d.detail : 'No se pudo eliminar');
                      } catch { setDMsg('Error de conexión'); }
                      setDBusy(false);
                    }}>Eliminar campaña</button>
                  )}
                  {c.status === 'sending' && <div className="cpx-sub">La campaña se está enviando. Las cifras se actualizan solas.</div>}
                  {dMsg && <div className="cpw-note">{dMsg}</div>}
                </div>
              </div>

              {(m.sent || 0) + (m.failed || 0) > 0 && (
                <div style={{ marginTop:16 }}>
                  <div className="cpd-lh">
                    <div className="cpw-lbl" style={{ margin:0 }}>Registro de envíos {dLogs && <span className="cpx-muted">· últimos {fmtN(dLogs.length)}</span>}</div>
                    <button className={`cpx-chip${dOnlyFailed ? ' on' : ''}`} onClick={() => setDOnlyFailed(v => !v)}>Solo fallidos</button>
                  </div>
                  <div className="cpx-table">
                    <div className="cpd-row cpx-row--h"><div>Número</div><div>Estado</div><div>Detalle</div><div>Hora</div></div>
                    {dLogs === null ? <div className="cpx-empty" style={{ border:'none', padding:20 }}><div className="cpx-sub">Cargando…</div></div>
                      : logs.length === 0 ? <div className="cpx-empty" style={{ border:'none', padding:20 }}><div className="cpx-sub">{dOnlyFailed ? 'No hay envíos fallidos.' : 'Sin registros.'}</div></div>
                      : logs.map(l => { const ls = LOGST[l.status] || { l:l.status, c:'#9CA3AF' }; return (
                        <div key={l.id} className="cpd-row"><div style={{ fontVariantNumeric:'tabular-nums' }}>{l.phone}</div><div><span className="cpx-st"><span className="cpx-dot" style={{ background:ls.c }}/>{ls.l}</span></div><div className="cpx-muted" title={l.error}>{l.error || '—'}</div><div className="cpx-muted">{fmtT(l.sentAt)}</div></div>
                      ); })}
                  </div>
                </div>
              )}

              {c.status === 'draft' && <div className="cpx-empty" style={{ marginTop:14 }}><div className="cpx-empty-t">Campaña en borrador</div><div className="cpx-sub">No se ha enviado.</div></div>}
            </div>
          </div>
        </div></CpPortal>
        );
      })()}

      {/* ══════════════════════════════════════════════════════ */}
      {/* ══════ MODAL: AGREGAR CONTACTO MANUAL ══════ */}
      {/* ══════════════════════════════════════════════════════ */}
      {showAddContact && (
        <div className="cp-overlay" onClick={e => { if (e.target === e.currentTarget) setShowAddContact(null); }}>
          <div className="cp-modal" style={{ maxWidth:420 }}>
            <div className="cp-modal-header">
              <h2 className="cp-modal-title">Agregar contacto</h2>
              <button className="cp-modal-close" onClick={() => setShowAddContact(null)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div className="cp-modal-body">
              <label className="cp-label">Teléfono</label>
              <input className="cp-input" placeholder="573152118736" value={acPhone} onChange={e => setAcPhone(e.target.value)} autoFocus />
              <label className="cp-label" style={{ marginTop:12 }}>Nombre (opcional)</label>
              <input className="cp-input" placeholder="Daniel" value={acName} onChange={e => setAcName(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter' && acPhone.trim()) document.getElementById('btn-add-contact')?.click(); }}
              />
              <button id="btn-add-contact" className="cp-btn-primary" style={{ width:'100%', marginTop:16, justifyContent:'center' }}
                disabled={!acPhone.trim()}
                onClick={async () => {
                  let phone = acPhone.trim().replace(/[^0-9+]/g, '');
                  if (/^3\d{9}$/.test(phone)) phone = '+57' + phone;
                  if (!phone.startsWith('+')) phone = '+' + phone;
                  try {
                    const r = await fetch(`${API}/campaigns/audiences/${showAddContact}/contacts`, {
                      method: 'POST', headers: authH(),
                      body: JSON.stringify([{ phone, name: acName.trim() }]),
                    });
                    if (r.ok) {
                      const d = await r.json();
                      setAudiences(prev => prev.map(a => a.id === showAddContact ? { ...a, count: d.total } : a));
                      setAcPhone(''); setAcName('');
                      alert(`Contacto agregado (${d.total} total)`);
                    } else {
                      alert('Error al agregar contacto');
                    }
                  } catch { alert('Error de conexión'); }
                }}
              >Agregar</button>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════ */}
      {/* ══════ MODAL: IMPORTAR CONTACTOS ══════ */}
      {/* ══════════════════════════════════════════════════════ */}
      {showImport && (
        <div className="cp-overlay" onClick={e => { if (e.target === e.currentTarget) { setShowImport(false); setImportFile(null); setImportPreview(null); setImportResult(null); }}}>
          <div className="cp-modal cp-modal-lg">
            <div className="cp-modal-header">
              <h2 className="cp-modal-title">Importar contactos</h2>
              <button className="cp-modal-close" onClick={() => { setShowImport(false); setImportFile(null); setImportPreview(null); setImportResult(null); }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div className="cp-modal-body">
              {importResult ? (
                <div style={{ textAlign:'center', padding:'20px 0' }}>
                  <div style={{ width:56, height:56, borderRadius:16, background: importResult.error ? '#ffeaea' : '#e8f5e9', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
                    {importResult.error ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff3b30" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#34c759" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
                    )}
                  </div>
                  <div style={{ fontSize:18, fontWeight:600, color:'#1d1d1f' }}>
                    {importResult.error ? 'Error al importar' : `${fmtN(importResult.importados)} contactos importados`}
                  </div>
                  {importResult.errores > 0 && (
                    <div style={{ fontSize:13, color:'#ff9500', marginTop:6 }}>{importResult.errores} filas con errores</div>
                  )}
                  <button className="cp-btn-primary" style={{ marginTop:24 }} onClick={() => { setShowImport(false); setImportFile(null); setImportPreview(null); setImportResult(null); }}>
                    Cerrar
                  </button>
                </div>
              ) : (
                <>
                  <div className="cp-field">
                    <label className="cp-label">Nombre de la lista</label>
                    <input className="cp-input" placeholder="Ej: Clientes Bogotá" value={importListName} onChange={e => setImportListName(e.target.value)} />
                  </div>

                  <input ref={fileRef} type="file" accept=".csv,.xlsx,.xls" style={{ display:'none' }} onChange={handleFileSelect} />
                  <div className={`cp-drop-zone${importFile ? ' has-file' : ''}`} onClick={() => fileRef.current?.click()}>
                    {importFile ? (
                      <>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#34c759" strokeWidth="1.5" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                        <div className="cp-drop-title">{importFile.name}</div>
                        <div className="cp-drop-desc">{importPreview ? `${fmtN(importPreview.total)} contactos encontrados` : 'Procesando...'}</div>
                      </>
                    ) : (
                      <>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#aeaeb2" strokeWidth="1.5" strokeLinecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                        <div className="cp-drop-title">Arrastra un archivo CSV aquí</div>
                        <div className="cp-drop-desc">o haz clic para seleccionar. Columnas: nombre, telefono, email, ciudad</div>
                      </>
                    )}
                  </div>

                  {importPreview && (
                    <>
                      <div style={{ fontSize:13, fontWeight:600, color:'#1d1d1f', marginTop:20, marginBottom:4 }}>Vista previa</div>
                      <table className="cp-preview-table">
                        <thead>
                          <tr>{importPreview.headers.map(h => <th key={h}>{h}</th>)}</tr>
                        </thead>
                        <tbody>
                          {importPreview.rows.map((r, i) => (
                            <tr key={i}>{importPreview.headers.map(h => <td key={h}>{r[h]}</td>)}</tr>
                          ))}
                        </tbody>
                      </table>
                      {importPreview.total > 5 && (
                        <div style={{ fontSize:12, color:'#aeaeb2', marginTop:8, textAlign:'center' }}>
                          Mostrando 5 de {fmtN(importPreview.total)} filas
                        </div>
                      )}
                    </>
                  )}

                  <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:24 }}>
                    <button className="cp-btn-secondary" onClick={() => { setShowImport(false); setImportFile(null); setImportPreview(null); }}>Cancelar</button>
                    <button
                      className="cp-btn-primary"
                      disabled={!importFile || !importListName.trim() || importing}
                      style={{ opacity: (!importFile || !importListName.trim() || importing) ? .4 : 1 }}
                      onClick={handleImport}
                    >
                      {importing ? 'Importando...' : 'Importar contactos'}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════ */}
      {/* ══════ MODAL: NUEVA LISTA ══════ */}
      {/* ══════════════════════════════════════════════════════ */}
      {/* ══════════════════════════════════════════════════════ */}
      {/* ══════ MODAL: CREAR PLANTILLA WHATSAPP ══════ */}
      {/* ══════════════════════════════════════════════════════ */}
      {showCreateTpl && (
        <div className="cp-overlay" onClick={e => { if (e.target === e.currentTarget) resetTplForm(); }}>
          <div className="cp-modal cp-modal-lg">
            <div className="cp-modal-header">
              <h2 className="cp-modal-title">Crear plantilla WhatsApp</h2>
              <button className="cp-modal-close" onClick={resetTplForm}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div className="cp-modal-body">
              {tplResult ? (
                <div style={{ textAlign:'center', padding:'20px 0' }}>
                  <div style={{ width:56, height:56, borderRadius:16, background: tplResult.ok ? '#e8f5e9' : '#ffeaea', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
                    {tplResult.ok ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#34c759" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff3b30" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
                    )}
                  </div>
                  <div style={{ fontSize:18, fontWeight:600, color:'#1d1d1f' }}>
                    {tplResult.ok ? 'Plantilla enviada a revisión' : 'Error al crear plantilla'}
                  </div>
                  <div style={{ fontSize:14, color:'#86868b', marginTop:8, maxWidth:400, margin:'8px auto 0', lineHeight:1.5 }}>
                    {tplResult.ok
                      ? `Meta revisará tu plantilla. Puede tomar entre 1 minuto y 24 horas. Estado: ${tplResult.status || 'PENDING'}`
                      : (typeof tplResult.error === 'string' ? tplResult.error : JSON.stringify(tplResult.error?.error?.error_user_msg || tplResult.error?.error?.message || tplResult.error, null, 2))
                    }
                  </div>
                  <button className="cp-btn-primary" style={{ marginTop:24 }} onClick={resetTplForm}>Cerrar</button>
                </div>
              ) : (
                <>
                  {/* Row 1: Name + Category + Language */}
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:16 }}>
                    <div className="cp-field">
                      <label className="cp-label">Nombre</label>
                      <input className="cp-input" placeholder="promo_black_friday" value={tplName} onChange={e => setTplName(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '_'))} autoFocus />
                      <div style={{ fontSize:11, color:'#aeaeb2', marginTop:4 }}>Solo minúsculas, números y _</div>
                    </div>
                    <div className="cp-field">
                      <label className="cp-label">Categoría</label>
                      <select className="cp-select" value={tplCategory} onChange={e => setTplCategory(e.target.value)}>
                        <option value="MARKETING">Marketing</option>
                        <option value="UTILITY">Utilidad</option>
                        <option value="AUTHENTICATION">Autenticación</option>
                      </select>
                    </div>
                    <div className="cp-field">
                      <label className="cp-label">Idioma</label>
                      <select className="cp-select" value={tplLang} onChange={e => setTplLang(e.target.value)}>
                        <option value="es_CO">Español (CO)</option>
                        <option value="es">Español</option>
                        <option value="es_MX">Español (MX)</option>
                        <option value="en_US">Inglés (US)</option>
                        <option value="en">Inglés</option>
                        <option value="pt_BR">Portugués (BR)</option>
                      </select>
                    </div>
                  </div>

                  {/* Header */}
                  <div className="cp-field">
                    <label className="cp-label">Encabezado (opcional)</label>
                    <div style={{ display:'flex', gap:8, marginBottom: tplHeaderType !== 'NONE' ? 10 : 0 }}>
                      {['NONE','TEXT','IMAGE','VIDEO','DOCUMENT'].map(ht => (
                        <button key={ht} className={`cp-filter${tplHeaderType === ht ? ' active' : ''}`}
                          style={{ fontSize:11, padding:'5px 12px' }}
                          onClick={() => setTplHeaderType(ht)}>
                          {ht === 'NONE' ? 'Sin encabezado' : ht === 'TEXT' ? 'Texto' : ht === 'IMAGE' ? 'Imagen' : ht === 'VIDEO' ? 'Video' : 'Documento'}
                        </button>
                      ))}
                    </div>
                    {tplHeaderType === 'TEXT' && (
                      <input className="cp-input" placeholder="Ej: ¡Hola {{1}}!" value={tplHeaderText} onChange={e => setTplHeaderText(e.target.value)} />
                    )}
                    {tplHeaderType !== 'NONE' && tplHeaderType !== 'TEXT' && (
                      <div>
                        <input ref={tplFileRef} type="file"
                          accept={tplHeaderType === 'IMAGE' ? 'image/png,image/jpeg' : tplHeaderType === 'VIDEO' ? 'video/mp4' : '.pdf,.doc,.docx'}
                          style={{ display:'none' }}
                          onChange={handleHeaderFileSelect}
                        />
                        {tplHeaderFile && tplHeaderHandle ? (
                          <div style={{ display:'flex', alignItems:'center', gap:12, background:'#e8f5e9', borderRadius:12, padding:14 }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#34c759" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
                            <div>
                              <div style={{ fontSize:14, fontWeight:600, color:'#1d1d1f' }}>{tplHeaderFile.name}</div>
                              <div style={{ fontSize:12, color:'#34c759' }}>Subido correctamente</div>
                            </div>
                            <button style={{ marginLeft:'auto', background:'none', border:'none', cursor:'pointer', color:'#ff3b30', fontSize:12, fontFamily:'inherit' }}
                              onClick={() => { setTplHeaderFile(null); setTplHeaderHandle(''); }}>
                              Quitar
                            </button>
                          </div>
                        ) : tplUploading ? (
                          <div style={{ background:'#f9f9fb', borderRadius:12, padding:20, textAlign:'center' }}>
                            <div style={{ fontSize:14, color:'#86868b' }}>Subiendo a Meta...</div>
                          </div>
                        ) : (
                          <div style={{ border:'2px dashed #d2d2d7', borderRadius:12, padding:24, textAlign:'center', cursor:'pointer', transition:'all .15s' }}
                            onClick={() => tplFileRef.current?.click()}
                            onMouseEnter={e => e.currentTarget.style.borderColor = '#007aff'}
                            onMouseLeave={e => e.currentTarget.style.borderColor = '#d2d2d7'}>
                            <div style={{ fontSize:14, fontWeight:500, color:'#1d1d1f' }}>
                              {tplHeaderType === 'IMAGE' ? 'Seleccionar imagen (PNG o JPG)' : tplHeaderType === 'VIDEO' ? 'Seleccionar video (MP4)' : 'Seleccionar documento (PDF)'}
                            </div>
                            <div style={{ fontSize:12, color:'#aeaeb2', marginTop:4 }}>Meta requiere un archivo de ejemplo para aprobar la plantilla</div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Body */}
                  <div className="cp-field">
                    <label className="cp-label">Cuerpo del mensaje</label>
                    <textarea className="cp-textarea" placeholder={'Ej: Hola {{1}}, tu pedido {{2}} ha sido despachado.\n\nUsa {{1}}, {{2}}, etc. para variables.'} value={tplBody} onChange={e => setTplBody(e.target.value)} style={{ minHeight:130 }} />
                    <div style={{ display:'flex', justifyContent:'space-between', marginTop:6, fontSize:12 }}>
                      <span style={{ color:'#aeaeb2' }}>
                        {tplVarsCount > 0 ? `${tplVarsCount} variable${tplVarsCount > 1 ? 's' : ''} detectada${tplVarsCount > 1 ? 's' : ''}` : 'Sin variables'}
                      </span>
                      <span style={{ color: tplBody.length > 1024 ? '#ff3b30' : '#aeaeb2' }}>{tplBody.length}/1024</span>
                    </div>
                  </div>

                  {/* Variable examples */}
                  {tplVarsCount > 0 && (
                    <div className="cp-field">
                      <label className="cp-label">Ejemplos de variables (requerido por Meta)</label>
                      <div style={{ display:'grid', gridTemplateColumns: tplVarsCount <= 3 ? `repeat(${tplVarsCount}, 1fr)` : 'repeat(3, 1fr)', gap:10 }}>
                        {tplBodyExamples.map((ex, i) => (
                          <input key={i} className="cp-input" style={{ fontSize:13 }}
                            placeholder={`Ejemplo para {{${i+1}}}`}
                            value={ex}
                            onChange={e => {
                              const next = [...tplBodyExamples];
                              next[i] = e.target.value;
                              setTplBodyExamples(next);
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Footer */}
                  <div className="cp-field">
                    <label className="cp-label">Pie de página (opcional)</label>
                    <input className="cp-input" placeholder="Ej: Tu tienda — tutienda.com" value={tplFooter} onChange={e => setTplFooter(e.target.value)} maxLength={60} />
                    <div style={{ fontSize:11, color:'#aeaeb2', marginTop:4, textAlign:'right' }}>{tplFooter.length}/60</div>
                  </div>

                  {/* Buttons */}
                  <div className="cp-field">
                    <label className="cp-label">Botones (opcional, máx. 3)</label>
                    {tplButtons.map((btn, i) => (
                      <div key={i} style={{ display:'grid', gridTemplateColumns:'130px 1fr 1fr auto', gap:8, marginBottom:8, alignItems:'center' }}>
                        <select className="cp-select" style={{ fontSize:12, padding:'8px 12px' }} value={btn.type} onChange={e => {
                          const next = [...tplButtons];
                          next[i] = { ...next[i], type: e.target.value };
                          setTplButtons(next);
                        }}>
                          <option value="QUICK_REPLY">Respuesta rápida</option>
                          <option value="URL">URL</option>
                          <option value="PHONE_NUMBER">Teléfono</option>
                        </select>
                        <input className="cp-input" style={{ fontSize:12, padding:'8px 12px' }}
                          placeholder="Texto del botón"
                          value={btn.text}
                          onChange={e => {
                            const next = [...tplButtons];
                            next[i] = { ...next[i], text: e.target.value };
                            setTplButtons(next);
                          }}
                        />
                        {btn.type !== 'QUICK_REPLY' && (
                          <input className="cp-input" style={{ fontSize:12, padding:'8px 12px' }}
                            placeholder={btn.type === 'URL' ? 'https://...' : '+573001234567'}
                            value={btn.value || ''}
                            onChange={e => {
                              const next = [...tplButtons];
                              next[i] = { ...next[i], value: e.target.value };
                              setTplButtons(next);
                            }}
                          />
                        )}
                        {btn.type === 'QUICK_REPLY' && <div />}
                        <button style={{ background:'none', border:'none', cursor:'pointer', color:'#ff3b30', padding:4 }}
                          onClick={() => setTplButtons(prev => prev.filter((_, j) => j !== i))}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                        </button>
                      </div>
                    ))}
                    {tplButtons.length < 3 && (
                      <button className="cp-btn-ghost" style={{ fontSize:12 }}
                        onClick={() => setTplButtons(prev => [...prev, { type:'QUICK_REPLY', text:'', value:'' }])}>
                        + Agregar botón
                      </button>
                    )}
                  </div>

                  {/* Preview */}
                  <div style={{ background:'#e5ddd5', borderRadius:16, padding:20, marginTop:8 }}>
                    <div style={{ fontSize:12, fontWeight:600, color:'#54656f', marginBottom:12, textTransform:'uppercase', letterSpacing:'.5px' }}>Vista previa</div>
                    <div style={{ background:'#fff', borderRadius:12, padding:14, maxWidth:340, boxShadow:'0 1px 3px rgba(0,0,0,.1)' }}>
                      {tplHeaderType === 'TEXT' && tplHeaderText && (
                        <div style={{ fontSize:14, fontWeight:700, color:'#1d1d1f', marginBottom:6 }}>{tplHeaderText}</div>
                      )}
                      {tplHeaderType !== 'NONE' && tplHeaderType !== 'TEXT' && (
                        tplHeaderFile && tplHeaderType === 'IMAGE' ? (
                          <div style={{ borderRadius:8, overflow:'hidden', marginBottom:8 }}>
                            <img src={URL.createObjectURL(tplHeaderFile)} alt="Header" style={{ width:'100%', display:'block', borderRadius:8 }} />
                          </div>
                        ) : (
                          <div style={{ background:'#f0f0f0', borderRadius:8, padding:20, textAlign:'center', marginBottom:8, color:'#86868b', fontSize:12 }}>
                            [{tplHeaderType === 'IMAGE' ? 'Imagen' : tplHeaderType === 'VIDEO' ? 'Video' : 'Documento'}]
                          </div>
                        )
                      )}
                      <div style={{ fontSize:14, color:'#111b21', lineHeight:1.5, whiteSpace:'pre-wrap' }}>
                        {tplBody || 'Escribe el cuerpo del mensaje...'}
                      </div>
                      {tplFooter && <div style={{ fontSize:12, color:'#8696a0', marginTop:8 }}>{tplFooter}</div>}
                      {tplButtons.length > 0 && (
                        <div style={{ borderTop:'1px solid #e9edef', marginTop:10, paddingTop:8 }}>
                          {tplButtons.map((b, i) => (
                            <div key={i} style={{ textAlign:'center', padding:'8px 0', color:'#007aff', fontSize:14, fontWeight:500,
                              borderTop: i > 0 ? '1px solid #e9edef' : 'none' }}>
                              {b.text || `Botón ${i+1}`}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Submit */}
                  <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:24 }}>
                    <button className="cp-btn-secondary" onClick={resetTplForm}>Cancelar</button>
                    <button
                      className="cp-btn-primary"
                      disabled={!tplName.trim() || !tplBody.trim() || tplBody.length > 1024 || tplSubmitting}
                      style={{ opacity: (!tplName.trim() || !tplBody.trim() || tplBody.length > 1024 || tplSubmitting) ? .4 : 1 }}
                      onClick={handleCreateTemplate}
                    >
                      {tplSubmitting ? 'Enviando a Meta...' : 'Enviar a revisión'}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {showNewList && (
        <div className="cp-overlay" onClick={e => { if (e.target === e.currentTarget) setShowNewList(false); }}>
          <div className="cp-modal" style={{ maxWidth:480 }}>
            <div className="cp-modal-header">
              <h2 className="cp-modal-title">Nueva lista</h2>
              <button className="cp-modal-close" onClick={() => setShowNewList(false)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div className="cp-modal-body">
              <div className="cp-field">
                <label className="cp-label">Nombre</label>
                <input className="cp-input" placeholder="Ej: Clientes frecuentes" value={nlName} onChange={e => setNlName(e.target.value)} autoFocus />
              </div>
              <div className="cp-field">
                <label className="cp-label">Descripción</label>
                <input className="cp-input" placeholder="Descripción opcional" value={nlDesc} onChange={e => setNlDesc(e.target.value)} />
              </div>
              <div className="cp-field">
                <label className="cp-label">Color</label>
                <div className="cp-colors">
                  {['#007aff','#34c759','#ff9500','#ff3b30','#af52de','#5ac8fa','#ff2d55','#5856d6'].map(c => (
                    <div key={c} className={`cp-color-dot${nlColor === c ? ' active' : ''}`} style={{ background: c }} onClick={() => setNlColor(c)}/>
                  ))}
                </div>
              </div>
              <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:8 }}>
                <button className="cp-btn-secondary" onClick={() => setShowNewList(false)}>Cancelar</button>
                <button className="cp-btn-primary" disabled={!nlName.trim()} style={{ opacity: !nlName.trim() ? .4 : 1 }} onClick={handleCreateList}>
                  Crear lista
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
